import { hot } from 'react-hot-loader/root';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadScript, displayCustomDialog, prepareSelectOptionsList, matchSKU } from 'util/Utils';
import async from 'async';
import ReactDOM from 'react-dom';
import { displaySellerAndPickupData } from 'dashboard/processing/3PLSharedMethods';
import {
  fetchSettings,
  startTimeTracking,
  startTimeTrackingInterval,
  stopAndStartTimeTracking,
  getVariationOptions,
} from 'shared/sharedMethods';
import {
  renderTopLevelCategory,
  SCREENS,
  renderDimensionsVerticalView,
  prepareProductAgeRange,
  prepareAndValidateProductData,
  toggleCategoryExpandedState,
  prepareModelsOptions,
  searchGBGProductsDebounce,
  displayNavigation,
  getAllSellerPickupsList,
  fetchGBGProductsTags,
  fetchBoxSizeSettings,
  selectCategory,
  prepareProductCategories,
  prepareAmazonProductData,
  prepareDataForWeight,
  prepareDataForDonation,
  displayTimeTrackingButtons,
  renderSubCategories,
  processQualityChecks,
  getQualityChecksForGBGProduct,
  getSimilarProducts,
  processSimilarProducts,
  prepareDataForNextScreen,
} from 'dashboard/processing/PostingSharedMethods';
import { displayScreenContent } from 'dashboard/processing/ProcessingScreensContent';
import { getSellerType } from 'dashboard/processing/ProcessingScreensMethods';
import { v4 as uuidv4 } from 'uuid';
import Collapsible from 'react-collapsible';
import { makeRequest, dispatchAction, getCurrentStoreState, displayMessage } from 'actions';
import {
  Row,
  Col,
  Form,
  FormGroup,
  Checkbox,
  Modal,
  OverlayTrigger,
  ControlLabel,
  FormControl,
  Button,
} from 'react-bootstrap';
import Select from 'react-select';
import moment from 'moment';
import { FETCH_ALL_SELLERS_LIST } from 'actions/actionTypes';

import config from '../../../config';
import _ from 'lodash';
import { getAllowedAgeGroups } from '../../shared/sharedMethods';
import Timer from './components/timer';
import { persistState } from './persistState';

var JsBarcode = require('jsbarcode');

export class ProductProcessingPage extends Component {
  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
    };
  }

  constructor(props, context) {
    super(props, context);
    const currentFlow =
      this.props.location.pathname.includes('/posting') || this.props.location.pathname.includes('/processing-seller')
        ? 'PostingFlow'
        : '3PLProcessingFlow';

    let initialScreen = this.props.location.pathname == "/admin/inboundRebound" ? SCREENS.inbound_rebound_screen.key : SCREENS.service_selection_screen.key;

    if (initialScreen == SCREENS.inbound_rebound_screen.key && !this.props.appData.FeatureFlags.EnableInboundReboundInTush) {
      window.location.href = config.getEnvironment().clientSideURL + '/admin';
    }

    if (
      currentFlow == 'PostingFlow' ||
      (this.props.location.pathname == '/admin/processing-3PL' && this.props.appData.FeatureFlags.UseGBGIDIn3PL)
    ) {
      initialScreen = SCREENS.barcode_scanning_screen.key;
    }

    let initialData = {};
    this.timerRef = {
      start() {},
      stop() {},
      toggle() {},
      reset() {},
      resetAndStart() {},
      getCurrentTime() {},
    };

    if (_.get(this.props.userReducer, ['user', 'MarketName'])) {
      initialData.servicesListMarkets = [
        {
          value: _.get(this.props.userReducer, ['user', 'MarketName']),
          label: _.get(this.props.userReducer, ['user', 'MarketName']),
        },
      ];
    }
    if (config.getEnvironmentName() == 'local') {
      initialData = {
        images: [],
        LocationInWarehouse: '1Ba',
        BarcodeNumber:
          currentFlow == '3PLProcessingFlow' && this.props.appData.FeatureFlags.UseGBGIDIn3PL ? 'G123' : '20.391.238',
        ProductName: '',
        PersonalNote: '',
        selectedGBGProduct: {},
        PalletBarcodeNumberText: '20.391.238',
        TrackingNumber: '', // 'tr12345',
        servicesListSearchText: '',
        GBGProductsBrand: 'BOB',
        GBGProductsModel: '',
      };
    }

    if (currentFlow == '3PLProcessingFlow') {
      const {
        processing3PLFlowSelectedLocations = [],
        processing3PLFlowSelectedSellerID,
        processing3PLFlowServiceSearchText,
      } = this.props.userReducer.customUserData;

      if (processing3PLFlowSelectedSellerID) {
        initialData.servicesListSellerID = processing3PLFlowSelectedSellerID;
        initialData.servicesListMarkets = [];
      }

      if (processing3PLFlowServiceSearchText) {
        initialData.servicesListSearchText = processing3PLFlowServiceSearchText;
      }
      if (processing3PLFlowSelectedLocations.length) {
        initialData.servicesListMarkets = processing3PLFlowSelectedLocations;
      }
    }
    this.state = {
      requestFlowId: uuidv4(),
      showModal: false,
      currentFlow: currentFlow,
      currentScreen: initialScreen,
      screensData: initialData,
      screensStack: [initialScreen],
      currentRecord: {},
      currentTimeTracked: _.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false)
        ? moment
            .utc(moment().diff(moment(this.props.userReducer.customUserData.timeTrackingStarted)))
            .format('HH:mm:ss')
        : '',
    };

    this.doNotLookUpForAmazonProducts = false;
    this.calculateRecommendedPriceData = false;
    this.recommendedPriceAmount = 'n/a';
    this.FeatureFlags = {};
    this.ProductsSettingsData = {
      FeatureFlags: {},
    };
    this.searchServicesDebounce = _.debounce(this.searchServices, 1000, {
      leading: false,
      trailing: true /* this should be true to include the latest call of the method */,
    });
    this.searchProductsDebounce = _.debounce(this.searchProducts, 1000, {
      leading: false,
      trailing: true /* this should be true to include the latest call of the method */,
    });

    if (_.size(this.props.allSellerPickupsListReducer.data) == 0) {
      getAllSellerPickupsList.call(this);
    }

    fetchSettings.call(this, 'FeatureFlags').then((result) => {
      this.FeatureFlags = result;

      if (
        this.props.appData.FeatureFlags.AppSettingsVersion &&
        result.AppSettingsVersion &&
        this.props.appData.FeatureFlags.AppSettingsVersion < result.AppSettingsVersion
      ) {
        console.log(
          'updating application version',
          result.AppSettingsVersion,
          this.props.appData.FeatureFlags.AppSettingsVersion
        );
        return window.top.location.reload();
      }
      if (this.props.location.pathname.includes('/processing-3PL-manager')) {
        this.FeatureFlags.Processing3PLByManager = true;
      }
    });
    fetchSettings.call(this, 'ProductsSettings').then((result) => {
      this.ProductsSettingsData = result;
    });
    fetchBoxSizeSettings.call(this);
    fetchGBGProductsTags.call(this);
    loadScript('https://cdn.jsdelivr.net/npm/jsbarcode@3.11.0/dist/JsBarcode.all.min.js');
    loadScript(config.getEnvironment().serverBaseURL + '/scripts/BrowserPrint-Zebra-1.0.216.min.js');
    loadScript(config.getEnvironment().serverBaseURL + '/scripts/BrowserPrint-3.0.216.min.js');
    // setTimeout(()=> {
    //     console.log('BrowserPrint', BrowserPrint  );
    //     this.loadDefaultPrintDevice()
    //
    // },4000)
  }
  componentDidMount() {
    var self = this;
    if (this.state.currentFlow == 'PostingFlow') {
      self.barcodeNumberInput && ReactDOM.findDOMNode(self.barcodeNumberInput).focus();
    }
  }

  generateBarcodes(params) {
    return new Promise((resolve, reject) => {
      if (_.get(this.state.screensData, 'Width', 2.2) > 4) {
        this.props.displayMessage({ messageType: 'warning', messageCode: 'Width can not be greater than 4' });
        return reject();
      }
      if (_.get(this.state.screensData, 'Height', 116) > 200) {
        this.props.displayMessage({ messageType: 'warning', messageCode: 'Width can not be greater than 200' });
        return reject();
      }
      if (_.get(this.state.screensData, 'Fontsize', 30) > 50) {
        this.props.displayMessage({
          messageType: 'warning',
          messageCode: 'Fonsize can not be greater than 50',
        });
        return reject();
      }
      var self = this,
        functionsToCall = [],
        methodParams = {
          // ProductID:  params.ProductID,

          fontSize: _.get(this.state.screensData, 'Fontsize', ''),
          width: _.get(this.state.screensData, 'Width', ''),
          marginLeft: _.get(this.state.screensData, 'LeftMargin', ''),
          height: _.get(this.state.screensData, 'Height', ''),
          action: 'generateBarcodeImage',
        };
      // if(_.get(self.state.screensData,  'barcodeImages',[]).length){
      //     resolve(_.get(self.state.screensData,  'barcodeImages',[]))
      // }

      if (self.state.screensData.BarcodeNumber == 'display_print_screen') {
        params.barcodesToGenerate = [_.get(self.state.screensData, 'CustomSKUToPrint', '123.35.46')];
      }
      console.log('generateBarcodes', methodParams, params.barcodesToGenerate);
      _.forEach(params.barcodesToGenerate, (barcodeText) => {
        functionsToCall.push(function (done) {
          self.props
            .makeRequest(
              _.extend({}, methodParams, {
                barcodeText:
                  _.get(self.state.screensData, 'CustomSKUToPrint', '') == ''
                    ? barcodeText
                    : _.get(self.state.screensData, 'CustomSKUToPrint'),
              }),
              {
                type: 'post',
                endpoint: '/products/customAction',
              }
            )
            .then((response) => {
              console.log('response.data', response.data);
              done(null, response.data);
            })
            .catch((error) => {
              console.log('error', error);
              done(error);
            });
        });
      });

      async.parallel(functionsToCall, function (err, responses) {
        console.log('responses', err, responses);
        if (err) {
          return reject(err);
        }
        resolve(responses);
      });
    });
  }
  printBarcodes(params) {
    return new Promise((resolve, reject) => {
      var self = this,
        functionsToCall = [];

      _.forEach(params.barcodeImages, (imageURL) => {
        functionsToCall.push(function (done) {
          if (params.convertImage1) {
            /*not working*/
            self.state.screensData.selectedPrinter.sendFile(
              imageURL,
              (success) => {
                console.log('printed', imageURL);
                done(null);
              },
              (errorMessage) => {
                self.props.displayMessage({
                  messageType: 'warning',
                  messageCode: errorMessage,
                });
                console.log('errorMessage', imageURL, errorMessage);
                done(errorMessage);
              }
            );
          } else if (params.convertImage4) {
            /* working*/
            self.state.screensData.selectedPrinter.convertAndSendFile(
              imageURL,
              (success) => {
                console.log('printed  4', imageURL);
                done(null);
              },
              (errorMessage) => {
                self.props.displayMessage({
                  messageType: 'warning',
                  messageCode: errorMessage,
                });
                console.log('errorMessage', imageURL, errorMessage);
                done(errorMessage);
              }
            );
          } else if (params.convertImage) {
            var zebraPrinter = new Zebra.Printer(self.state.screensData.selectedPrinter);
            console.log('zebraPrinter', zebraPrinter);
            try {
              zebraPrinter.convertAndSendFile(imageURL).then(
                function () {
                  console.log('printed', imageURL);
                  done(null);
                },
                (errorMessage) => {
                  console.log('errorMessage', imageURL, errorMessage);
                  self.props.displayMessage({
                    messageType: 'warning',
                    messageCode: errorMessage,
                  });

                  done(errorMessage);
                }
              );
            } catch (err) {
              console.log('in catch', err);
              done(err);
            }
          } else {
            /*not working*/
            self.state.screensData.selectedPrinter.send(
              imageURL,
              (success) => {
                console.log('printed', imageURL);
                done(null);
              },
              (errorMessage) => {
                self.props.displayMessage({
                  messageType: 'warning',
                  messageCode: errorMessage,
                });
                console.log('errorMessage', imageURL, errorMessage);
                done(errorMessage);
              }
            );
          }
        });
      });
      console.log('functionsToCall', functionsToCall);
      async.series(functionsToCall, function (err, responses) {
        console.log('err', err);
        console.log('responses', responses);
        if (err) {
          return reject(err);
        }
        resolve(responses);
      });
    });
  }
  displayBarcode() {
    //   var canvas = this.barcodeCanvas

    // const ctx = canvas.getContext('2d');
    //  const barcodeMargin = 35;
    //
    //  JsBarcode(canvas, '20.3.121', {
    //      format: 'CODE128',
    //      ean128: false,
    //      textMargin: 0,width:2.2,height: 70, fontSize:  26,
    //  });
    //
    //  const x = (-canvas.width / 2) + barcodeMargin;
    //  const y = barcodeMargin - (barcodeMargin / 2);
    //
    //
    //  ctx.fontFamily = ' "Work Sans", "HelveticaNeue", "Helvetica Neue", sans-serif'
    //
    //  ctx.fillStyle = 'black';
    //
    //  ctx.fillText("Justin Says Hello".toUpperCase(), x, y, canvas.width);
    JsBarcode('#barcodeSVG', '20.3.129', {
      textMargin: 0,
      width: 2.2,
      height: 80,
      fontSize: 26,
      format: 'CODE128',
    });
    var s = new XMLSerializer();
    var svg = s.serializeToString(this.barcodeSVG);

    // JsBarcode("#barcodeCanvas", "20.3.128", {
    //     textMargin: 0, width: 2.2, height: 70, fontSize: 28, format: "CODE128"
    // });
    // var canvasURL = canvas.toDataURL("image/png");
    /// var encodedData = 'data:image/svg+xml;base64,' + window.btoa(svg);
    const blob = new Blob([svg], {
      type: 'image/svg+xml',
    });
    // this.barcodeSVG.toBlob(function(blob){
    //   var  href = URL.createObjectURL(blob);
    //    // self.barcodeImage.src =href
    //     console.log('href',href); // this line should be here
    // },'image/png');
    var link = URL.createObjectURL(blob);
    console.log('link', link);
    //   self.barcodeImage.onload = function () {
    //   //    ctx.drawImage(self.barcodeImage, 0, 0, 291, 116 );
    //  // var  imgInfo = canvas.toDataURL("image/png");
    // //  console.log('imgInfo', imgInfo  );
    //   }
    // canvas.toBlob(function (blob) {
    //  //  link.href = URL.createObjectURL(blob);
    //    // console.log('blob', blob);
    //     resolve(blob)
    // }, 'image/png');
  }

  loadDefaultPrintDevice() {
    var self = this;
    BrowserPrint.getLocalDevices(function (deviceList) {
      console.log('getLocalDevices', deviceList);
    });
    BrowserPrint.getDefaultDevice(
      'printer',
      function (device) {
        console.log('getDefaultDevice', device);

        // device.send("~wc", function(success){
        //     console.log("Sent to printer");}, function(error){
        //     console.error("Device sent Error:" + error)
        //     ;});

        setTimeout(() => {
          device.send(
            '^XA^HH^XZ',
            function (success) {
              device.read(
                function (response) {
                  console.log('Configuration read success', response);
                },
                function (error) {
                  console.log('Configuration read error', error);
                }
              );
            },
            function (error) {
              console.log('Configuration sent error ', error);
            }
          );
        }, 5000);
        var zebraPrinter = new Zebra.Printer(device);
        console.log('zebraPrinter', zebraPrinter);
        zebraPrinter
          .isPrinterReady()
          .then(function () {
            console.log('zebraPrinter is ready');
            return zebraPrinter.write('~wc');
          })
          .catch(function (error) {
            console.log('zebraPrinter is ready error', error);
          });
      },
      function (error) {
        console.log('getDefaultDevice error', error);

        if (error == '') {
          self.props.displayMessage({
            messageType: 'warning',
            messageCode: 'Please, install client application or connect a printer to the computer',
          });
        } else {
          self.props.displayMessage({
            messageCode: JSON.stringify(error),
          });
        }
      }
    );
  }
  componentWillMount() {
    this.props
      .makeRequest(
        { convertToTreeData: true },
        {
          endpoint: '/categories',
          not_display_success_message: true,
        }
      )
      .then((response) => {
        //  console.log('JSON.stringify(response.data.data)', JSON.stringify(response.data.data)  );
        this.setState({
          AllCategories: _.cloneDeep(response.data.data),
          allCategoriesOriginal: response.data.data,
        });
      });
    var self = this;
    if (_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false)) {
      startTimeTrackingInterval.call(this, _.get(this.props.userReducer, ['customUserData']));
    }

    if (self.state.currentFlow == '3PLProcessingFlow') {
      self.searchServices();
    }
    if (config.getEnvironmentName() == 'local') {
      self.searchProducts({});
    }
    if (_.size(self.props.allSellersList.data) == 0) {
      var methodData = {
        success_event: FETCH_ALL_SELLERS_LIST,
        endpoint: '/sellers',
        not_display_success_message: true,
      };
      this.props
        .makeRequest({ sortBy: 'DisplayName:1', all: true, include: ['DisplayName', 'InventoryOwnership'] }, methodData)
        .catch((err) => {});
    }
    self.allSellersOptionsList = prepareSelectOptionsList(self.props.allSellersList.data, {
      label: 'DisplayName',
      value: '_id',
      customOptionFields: [{ fieldName: 'InventoryOwnership', path: 'InventoryOwnership' }],
    });
    this.props
      .makeRequest(
        { type: 'getAllBrandsWithModels' },
        {
          endpoint: '/gbg_products_data',
          type: 'post',
          not_display_success_message: true,
        }
      )
      .then((response) => {
        this.setState(
          {
            allBrandsWithModels: _.orderBy(
              _.map(_.get(response.data, 'data', []), (item) => {
                return { value: item.Brand, label: item.Brand, Models: item.Models };
              }),
              'label',
              'asc'
            ),
          },
          () => {
            prepareModelsOptions.call(self);
          }
        );
      })
      .catch((err) => {});
  }

  componentWillReceiveProps(nextProps) {
    var self = this;

    if (
      _.get(nextProps.userReducer, ['customUserData', 'timeTrackingStarted'], false) &&
      !_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false)
    ) {
      /* time tracking started */
      startTimeTrackingInterval.call(this, _.get(nextProps.userReducer, ['customUserData'], {}));
    } else if (
      _.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false) &&
      !_.get(nextProps.userReducer, ['customUserData', 'timeTrackingStarted'], false)
    ) {
      /* time tracking stopped */
      clearInterval(this.intervalID);
    }

    if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
      this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
        label: 'DisplayName',
        value: '_id',
        customOptionFields: [{ fieldName: 'InventoryOwnership', path: 'InventoryOwnership' }],
      });
    }
  }

  componentWillUnmount() {
    if (this.timerRef) {
      this.timerRef.stop();
    }
    clearInterval(this.intervalID);
  }
  updateScreensData(params = {}) {
    var self = this;
    var fieldsToKeep = [];
    if (this.state.currentFlow == '3PLProcessingFlow') {
      fieldsToKeep = [
        'currentServiceRecord',
        'TrackingNumbers',
        'PalletType',
        'productAction',
        'SellerID',
        'PickupID',
        'SKU',
        'LocationInWarehouse',
        'GBGProductsearchText',
        'listingsSearchText',
        'GBGProductsBrand',
        'Condition',
        'Details',
        'GBGProductsModel',
        'servicesListSearchText',
        'servicesListSellerID',
        'PalletBarcodeNumberText',
        'BarcodeNumber',
        'TrackingNumber',
        'RMAProducts',
        'sendRMAProductProcessedEvents',
        'SerialNumber',
      ];
    } else {
      fieldsToKeep = [
        'SellerID',
        'PickupID',
        'ProductNumber',
        'TrackingNumber',
        'LocationInWarehouse',
        'BarcodeNumber',
        'CurrentProductData',
        'productAction',
        'SerialNumber',
      ];
    }
    fieldsToKeep = _.concat(fieldsToKeep, _.get(params, 'additionalFieldsToKeep', []));
    console.log('updateScreensData', _.get(params, 'additionalFieldsToKeep', []));
    var dataToUpdate = {
      screensData: _.pick(this.state.screensData, fieldsToKeep),
    };
    if (params.upToCurrentScreen) {
      var currentScreenIndex = _.findIndex(this.state.screensStack, (item) => {
        return item == this.state.currentScreen;
      });
      var screensStackToUse = this.state.screensStack.slice(0, currentScreenIndex + 1);

      dataToUpdate.screensStack = screensStackToUse;
    }
    _.pullAll(dataToUpdate.screensStack, [SCREENS.confirmation_screen]);
    // console.log('dataToUpdate', dataToUpdate  );
    this.setState(dataToUpdate, () => {
      params.callbackMethod();
    });
  }
  resetScreensData = (params = {}) => {
    var self = this;
    var nextScreen = SCREENS.service_selection_screen.key;
    var datToSet = {};

    if (self.state.currentFlow == 'PostingFlow' || self.props.location.pathname == '/admin/processing-3PL') {
      nextScreen = SCREENS.barcode_scanning_screen.key;
    }

    if(self.props.location.pathname == '/admin/inboundRebound' ){
      nextScreen = SCREENS.inbound_rebound_screen.key;
    }

    if (params.nextScreen) {
      nextScreen = params.nextScreen;
    }

    let fieldsToKeep = ['servicesListSellerID', 'servicesListSearchText'];
    if (params.fieldsToKeep) {
      fieldsToKeep = fieldsToKeep.concat(params.fieldsToKeep);
    }

    datToSet = _.pick(this.state.screensData, fieldsToKeep);
    this.setState(
      {
        AllCategories: _.cloneDeep(_.get(self.state, 'allCategoriesOriginal', [])),
        currentScreen: nextScreen,
        screensData: datToSet,
        pending: false,
        screensStack: [nextScreen],
      },
      () => {
        /// this.goToNextScreen(SCREENS.service_selection_screen.key)
        var processingPage = document.getElementById('processing-page');
        if (processingPage) {
          processingPage.scrollIntoView();
        }
        if (params.resetScreensCallback) {
          params.resetScreensCallback.call(self);
        } else if (self.state.currentFlow == '3PLProcessingFlow') {
          self.searchServices();
        }
      }
    );
  };

  renderVariationsForSelectedGBGProduct() {
    if (_.get(this.state.screensData, 'selectedGBGProduct.Variations', []).length == 0) {
      return null;
    }
    return (
      <Row>
        {_.map(
          _.get(this.state.screensData, 'selectedGBGProduct.Variations', []),
          function (variation, variationIndex) {
            return (
              <Col md={2} sm={2} xs={6} className="top10">
                {variation.InputType == 'select' && (
                  <Select
                    clearable={true}
                    placeholder={variation.Label}
                    options={getVariationOptions(variation)}
                    onChange={(option) => {
                      console.log('option', option);
                      var self = this;
                      var dataToUpdate = {
                        ...this.state.screensData.modelVariations,
                      };
                      if (option) {
                        dataToUpdate[variation.Label] = option.value;
                      } else {
                        delete dataToUpdate[variation.Label];
                      }
                      this.setScreensData(
                        {
                          modelVariations: dataToUpdate,
                        },
                        () => {
                          self.searchProductsDebounce({});
                        }
                      );
                    }}
                    value={_.get(this.state.screensData, ['modelVariations', variation.Label])}
                  />
                )}
                {variation.InputType == 'input' && (
                  <FormControl
                    type="text"
                    onChange={(e) => {
                      this.setScreensData(
                        {
                          modelVariations: {
                            ...this.state.screensData.modelVariations,
                            [variation.Label]: e.target.value,
                          },
                        },
                        () => {}
                      );
                    }}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        this.searchProductsDebounce({});
                      }
                    }}
                    value={_.get(this.state.screensData, ['modelVariations', variation.Label], '')}
                    placeholder={variation.Label}
                  />
                )}
              </Col>
            );
          }.bind(this)
        )}
      </Row>
    );
  }

  searchServices(params = {}) {
    var self = this,
      queryParams = { perPage: 50 };

    self.setState({ showWaitingWheel: true });
    if (!_.isUndefined(params.page) && params.page !== 1) {
      queryParams.page = params.page;
    }
    var methodData = {
      endpoint: '/pickups',
      timeout: 25019,
      success_event_data: {
        page: params.page ? (isNaN(params.page) ? 1 : params.page) : 1,
      },
      not_display_success_message: true,
    };

    if (self.state.screensData.servicesListSellerID) {
      queryParams.SellerID = self.state.screensData.servicesListSellerID;
    }
    if (self.state.screensData.servicesListSearchText) {
      queryParams.searchText = self.state.screensData.servicesListSearchText;
      queryParams.WGServices = true;
    }
    if (_.size(self.state.screensData, 'servicesListMarkets', [])) {
      queryParams.Markets = _.map(self.state.screensData.servicesListMarkets, 'value');
    }
    if (self.state.screensData.servicesListSortBy) {
      queryParams.sortBy = self.state.screensData.servicesListSortBy;
    }
    if (this.state.currentFlow == '3PLProcessingFlow') {
      queryParams.PartnerIDExists = true;
    }
    //   if( queryParams.PartnerIDExists) {
    queryParams.StatusesToExclude = ['Cancelled', 'Active', 'Archived'];
    //  } else{
    //       queryParams.Statuses = ['Scheduled']
    //    }
    if (_.isUndefined(queryParams.sortBy)) {
      //queryParams.sortBy = 'createdAt:-1'
      queryParams.sortBy = 'ServiceStartTime:-1';
    }
    queryParams.lookup = ['Sellers', 'Users'];
    if (queryParams.PalletIDExists) {
      queryParams.lookup.push('Pallet');
    }

    this.props
      .makeRequest(queryParams, methodData)
      .then((res) => {
        self.setScreensData({
          servicesListData: res.data.data,
          servicesListTotal: res.data.total,
          servicesListPage: _.get(queryParams, 'page', 1) - 1,
          servicesListFetched: true,
        });
        self.setState({ showWaitingWheel: false });
      })
      .catch((err) => {
        //  clearTimeout(this.showWaitingWheelTimeoutMethod)
        //  this.setState({showWaitingWheel: false})
        self.setState({ showWaitingWheel: false });
      });
  }
  searchProducts = (params = {}) => {
    var self = this;
    var queryParams = {};
    console.log('searchProducts params', params);

    if (!_.isUndefined(params.page) && params.page !== 1) {
      queryParams.page = params.page;
    }
    var textToCheck = _.trim(_.get(this.state.screensData, 'listingsSearchText', ''));
    if (textToCheck.length > 3) {
      var match = textToCheck.match(/^[\s]*(\.)?(\d+)(\.)?(\d+)?(\.)?(\d+)?/);

      if (match) {
        queryParams.customSearchText = textToCheck;
        queryParams.customSearchFields = ['SKU'];
      } else {
        queryParams.text = this.state.screensData.listingsSearchText;
      }
    }
    var methodData = {
      endpoint: '/products',
      timeout: 25038,
      not_display_success_message: true,
    };
    if (_.get(this.state.screensData, 'Condition', 0) > -1) {
      queryParams.Conditions = [
        _.get(_.find(config.conditionsData, { number: this.state.screensData.Condition }), ['tag'], ''),
      ];
    }

    queryParams.ShopifyListingStatusesToExclude = ['Archived'];
    queryParams.SellerNumbers = [_.get(this.state.screensData, 'currentServiceRecord.SellerID.SellerNumber')];

    queryParams.SellerPickupNumber = _.get(this.state.screensData, ['currentServiceRecord', 'SellerPickupNumber'], '');
    queryParams.listingStatuses = ['Prelistings', 'Listings'];
    if (_.get(this.state.screensData, 'selectedGBGProduct._id')) {
      queryParams.GBGProductID = _.get(this.state.screensData, 'selectedGBGProduct._id');
      queryParams.ProductVariationsToMatch = [];
      _.forOwn(_.get(this.state.screensData, 'modelVariations', {}), (value, key) => {
        var modelVariation = { label: key, value: value };

        if (!modelVariation.label.includes('###')) {
          /* do not apply model variations selected on gbg_product_details screen */
          queryParams.ProductVariationsToMatch.push(modelVariation);
        }
      });
      if (_.size(queryParams.ProductVariationsToMatch)) {
        queryParams.ProductVariationsToMatch = JSON.stringify(queryParams.ProductVariationsToMatch);
      }
    }
    if (_.get(params, 'GBGProductIDs', []).length) {
      queryParams.GBGProductIDs = params.GBGProductIDs;
    }
    queryParams.status = 'all';
    queryParams.quantity = 'all';
    queryParams.perPage = 50;
    queryParams.lookup = ['Pickup', 'SellerID'];
    if (_.isUndefined(queryParams.sortBy)) {
      queryParams.sortBy = 'ProductNumber:-1';
    }
    if (config.getEnvironmentName() == 'local') {
      delete queryParams.Conditions;
      delete queryParams.SellerPickupNumber;
      queryParams.SellerNumbers = [];
    }

    let upcCodeToCheck = this.state.screensData.upcCodeToSave || this.state.screensData.lastValidUPCCode;
    const { selectedGBGProduct = {} } = this.state.screensData;
    const { Model = '', Brand = '' } = selectedGBGProduct;

    if (Model.toLowerCase().includes('to sell') || ['bundle', 'unknown'].includes(Brand.toLowerCase())) {
      upcCodeToCheck = false;
    }

    if (this.state.currentFlow == '3PLProcessingFlow' && upcCodeToCheck) {
      queryParams.UPCCodeNumber = upcCodeToCheck;
    }

    return this.props
      .makeRequest(queryParams, methodData)
      .then((res) => {
        if (params.returnProductData) {
          return res.data.data;
        } else {
          self.setScreensData({
            listingsData: res.data.data,
            listingsPage: _.get(queryParams, 'page', 1) - 1,
            listingsTotal: res.data.total,
            GBGProductsFetched: false,
            listingsFetched: true,
          });
        }
      })
      .catch((err) => {
        return;
      });
  };

  customSelectCategory(params) {
    console.log('customSelectCategory', params);
    var self = this;
    this.setState(
      {
        AllCategories: selectCategory.call(this, {
          selected: params.selected,
          expanded: params.expanded,
          categoryID: params.categoryID,
          subCategoryID: params.subCategoryID,
        }),
        selectedGBGProduct: {},
      },
      function () {
        searchGBGProductsDebounce.call(self, {});
      }
    );
    //    })
  }

  async goToNextScreen(nextScreen = '', params = {}) {
    if (nextScreen) {
    } else {
      nextScreen = '';
    }
    var dataToUpdate = {
      pending: false,
      currentScreen: nextScreen,
    };
    var nextScreenIndex = _.findIndex(this.state.screensStack, (item) => {
      return item == nextScreen;
    });
    var currentScreens = [...this.state.screensStack];

    if (params.screensToKeep) {
      currentScreens = _.difference(currentScreens, params.screensToKeep);
    }

    var screensDataToUpdate = await prepareDataForNextScreen.call(this, {
      nextScreenIndex: nextScreenIndex,
      screenName: nextScreen,
    });
    if (!_.isEmpty(screensDataToUpdate)) {
      dataToUpdate.screensData = {
        ...this.state.screensData,
        ...screensDataToUpdate,
      };
    }
    if (_.get(params, 'screenDataToSet')) {
      /* if setScreenData is called after goToNextScreen there can be race condition of updating state data*/
      dataToUpdate.screensData = _.extend(
        { ...this.state.screensData },
        _.get(dataToUpdate, 'screensData', {}),
        _.get(params, 'screenDataToSet')
      );
    }
    if (nextScreenIndex == -1) {
      dataToUpdate.screensStack = _.concat(currentScreens, [nextScreen]);
    }
    if (params.screensToRemove) {
      console.log('params.screensToRemove', params.screensToRemove);
      if (dataToUpdate.screensStack) {
        _.pullAll(dataToUpdate.screensStack, params.screensToRemove);
      } else {
        _.pullAll(currentScreens, params.screensToRemove);
        dataToUpdate.screensStack = currentScreens;
      }
    }

    this.setState(dataToUpdate, function () {
      var processingPage = document.getElementById('processing-page');
      if (processingPage) {
        processingPage.scrollIntoView();
      }
      if (params.nextScreenCallback) {
        params.nextScreenCallback();
      }
    });

    persistState(this.state.currentScreen, this.state, this.props, this.FeatureFlags);
  }

  getNextSKU() {
    return new Promise((resolve, reject) => {
      var methodData = {
        type: 'post',
        endpoint: '/process-action',
        not_display_success_message: true,
      };
      this.props
        .makeRequest(
          {
            action: 'GetNextProductNumber',
            PickupID: _.get(this.state.screensData, ['currentServiceRecord', '_id'], ''),
          },
          methodData
        )
        .then((res) => {
          resolve(res.data.ProductNumber);
        })
        .catch((err) => {
          resolve(false);
        });
    });
  }
  convertSVGToPNG(SVGString) {
    return new Promise((resolve, reject) => {
      var methodData = {
        type: 'post',
        endpoint: '/test',
        not_display_success_message: true,
      };

      this.props
        .makeRequest(
          {
            SVGString: SVGString,
          },
          methodData
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(false);
        });
    });
  }
  displayConditionsList(params = {}) {
    let conditionsToDisplay = [];
    if (this.state.currentFlow == '3PLProcessingFlow') {
      conditionsToDisplay = _.reject(config.conditionsData, (item) => {
        if (this.FeatureFlags.DeterministicCondition) return !_.includes(['Dispose'], item.value);
        else return _.includes(['Brand New'], item.value);
      });
    } else {
      conditionsToDisplay = _.reject(config.conditionsData, (item) => _.includes(['Dispose'], item.value));
    }
    //This is the dispose, 'Dispose, "Dispose" checkbox
    return (
      <Row className="top30 bot30">
        {_.map(conditionsToDisplay, (item) => {
          return (
            <Col key={`condition-${item.number}`} xs={12} className="set-width pleft0 align-center text-left">
              <Checkbox
                onChange={(e) => {
                  var dataToUpdate = { Condition: item.number };
                  if (this.state.currentFlow == '3PLProcessingFlow') {
                    dataToUpdate.TrackingNumbers = [
                      {
                        ...this.state.screensData.TrackingNumbers[0],
                        UserImageURL: '',
                        UserNotes: '',
                        Disposition: item.disposition,
                      },
                    ];
                  }
                  this.setScreensData(dataToUpdate);
                }}
                checked={this.state.screensData.Condition == item.number}
                inline
              >
                <span className="left5">{item.label}</span>
              </Checkbox>
            </Col>
          );
        })}
      </Row>
    );
  }
  renderReasonCodes() {
    return (
      <div className="left10 top15 bot30">
        {_.map(
          [
            { value: 'GrosslyMisinterpreted', label: 'Grossly misinterpreted' },
            { value: 'ItemMissing', label: 'Item missing' },
            { value: 'ItemDamagedInShipping', label: 'Item damaged in shipping' },
            { value: 'DifferentQuantityReceived', label: 'Different quantity received' },
          ],
          (item) => {
            return (
              <div className="  pleft0 align-center text-left">
                <Checkbox
                  onChange={(e) => {
                    this.setScreensData({ ReasonCode: item.value });
                  }}
                  checked={this.state.screensData.ReasonCode == item.value}
                  inline
                >
                  <span className="left5">{item.label}</span>
                </Checkbox>
              </div>
            );
          }
        )}
      </div>
    );
  }
  displayNotesTextInput() {
    return (
      <div>
        <div className="font-size-17   top20 text-left  set-width align-center text-bold">
          {'Add Internal Notes (Optional)'}
        </div>
        <div className="top5 align-center set-width">
          <FormControl
            data-testid="add-internal-notes-input"
            value={_.get(this.state.screensData, 'TrackingNumbers.0.UserNotes', '')}
            componentClass="textarea"
            style={{ borderRadius: 5, borderWidth: 1, height: 70, backgroundColor: '#FCF8CB', borderColor: '#c9c9c9' }}
            placeholder=""
            onChange={(e) => {
              this.setScreensData({
                TrackingNumbers: [{ ...this.state.screensData.TrackingNumbers[0], UserNotes: e.target.value }],
              });
            }}
            type="text"
          />
        </div>
      </div>
    );
  }

  displayCategoryList() {
    return (
      <div>
        {this.state.currentScreen == 'categories_screen' && _.get(this.state.screensData, 'GBGProductNotFound') && (
          <div
            onClick={() => {
              var dataToSave = {
                selectedCategories: [],
              };

              dataToSave.ProductCategories = prepareProductCategories.call(this, {
                selectedGBGProduct: _.get(this.state.screensData, 'selectedGBGProduct', {}),
                selectedCategories: [],
                AllCategories: this.state.AllCategories,
              });

              var customParams = {
                qualityChecksNotFoundScreen: SCREENS.fees_screen.key,
              };

              this.goToQualityCheckScreen(dataToSave, customParams);
            }}
            className="cursor-pointer text-left font-size-17 purple underlineText"
          >
            {"I don't know, skip this step"}
          </div>
        )}
        {_.get(this.state, 'AllCategories', []).map((category, rowID) => {
          return (
            <Collapsible
              className="text-left top5 bot5"
              openedClassName="text-left top5 bot5"
              //    transitionTime="5000" not working when
              //  transitionOpenTime="5000"
              //  transitionCloseTime="4000"
              //trigger="Top"
              trigger={
                <div>
                  {' '}
                  {renderTopLevelCategory.call(
                    this,
                    category,
                    this.customSelectCategory.bind(this),
                    toggleCategoryExpandedState
                  )}
                </div>
              }
              //    open={true}
              open={_.get(category, ['expanded'], false)}
              // onTriggerOpening={(isExpanded) => {
              //      this.setState({expanded: true})
              // }}
              // onTriggerClosing={(isExpanded) => {
              //     this.setState({expanded: false})
              // }}
              handleTriggerClick={(isExpanded) => {
                this.setState({ expanded: false });
              }}
              key={rowID + (_.get(category, ['expanded']) ? 'expanded' : 'not')}
            >
              <div>{renderSubCategories(category, this.customSelectCategory.bind(this))}</div>
            </Collapsible>
          );
        })}
      </div>
    );
  }
  prepareQualityCheckItemsData(customData = {}) {
    return new Promise(async (resolve, reject) => {
      var self = this,
        dataToSave = {};
      let additionalQualityChecksQueryParams = {};
      const {
        QualityChecksToExclude = [],
        QualityChecksToInclude = [],
        GBGProductImages = [],
      } = self.state.screensData.selectedGBGProduct || {};
      const { images = [] } = customData;
      if (QualityChecksToExclude.length) {
        additionalQualityChecksQueryParams.ItemsNumberToExclude = QualityChecksToExclude;
      }
      if (QualityChecksToInclude.length) {
        additionalQualityChecksQueryParams.ItemsNumberToInclude = QualityChecksToInclude.filter((item) => {
          return item.ItemNumber;
        }).map((item) => {
          const { QualityCheckRules = [] } = item;
          return { ItemNumber: item.ItemNumber, QualityCheckRules: QualityCheckRules };
        });
      }
      const customParams = {
        customQualityChecksToInclude: QualityChecksToInclude.filter((item) => {
          return _.isUndefined(item.ItemNumber);
        }).map((item) => {
          return { ...item, qualityCheckType: 'Custom', customQualityCheck: true, _id: uuidv4() };
        }),
        additionalQualityChecksQueryParams: additionalQualityChecksQueryParams,
      };
      await getQualityChecksForGBGProduct
        .call(self, _.extend({}, self.state.screensData, customData), customParams)
        .then(async (qualityCheckItemsResponse) => {
          dataToSave.recommendedPriceAmount = self.recommendedPriceAmount;
          qualityCheckItemsResponse.data = await processQualityChecks.call(self, qualityCheckItemsResponse.data);
          if (_.get(qualityCheckItemsResponse, 'data', []).length == 0) {
            dataToSave.qualityCheckItems = [];
            dataToSave.qualityCheckQueryParams = {};
          } else {
            // dataToSave.qualityCheckItems =_.cloneDeep(qualityCheckItemsResponse.data)
            dataToSave.currentQualityCheckRecord = _.get(qualityCheckItemsResponse.data, '0', {});
            dataToSave.baseQualityCheckItems = qualityCheckItemsResponse.data.filter(
              (item) => item.qualityCheckType == config.deterministicQualityCheckTypes.Base
            );
            dataToSave.baseQualityCheckItems.length
              ? (dataToSave.baseQualityCheckItems[0].firstBaseQualityCheck = true)
              : '';
            dataToSave.qualityCheckItems = qualityCheckItemsResponse.data;
            dataToSave.qualityCheckQueryParams = _.get(qualityCheckItemsResponse, 'qualityCheckQueryParams', {});
          }

          console.log('dataToSave', dataToSave);
          resolve(dataToSave);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  goToQualityCheckScreen(dataToSave, customParams = {}) {
    console.log("============== goToQualityCheckScreen =======================")
    console.log(dataToSave)
    var self = this,
      nextScreen = SCREENS.quality_checks_screen.key;

    self.prepareQualityCheckItemsData(dataToSave).then((dataToUpdate) => {
      let sellerType = getSellerType.call(self);

      if (self.FeatureFlags.DeterministicCondition) {
        dataToUpdate.currentConditionRating = 100; /* set initial condition */
        const currentCondition = config.conditionsData
          .filter((item) => item.scaleData)
          .find((condition) => {
            return (
              condition.scaleData[sellerType] &&
              dataToUpdate.currentConditionRating >= condition.scaleData[sellerType][0] &&
              dataToUpdate.currentConditionRating <= condition.scaleData[sellerType][1]
            );
          });
        dataToUpdate.Condition = currentCondition.number;
      }

      console.log('dataToUpdate', dataToUpdate);
      dataToUpdate.qualityCheckRecordsMatched = true;
      _.extend(dataToSave, dataToUpdate);
      if (_.get(dataToSave, 'qualityCheckItems', []).length == 0) {
        dataToUpdate.qualityCheckRecordsMatched = false;
        nextScreen = SCREENS.fees_screen.key;
        if (customParams.qualityChecksNotFoundScreen) {
          nextScreen = customParams.qualityChecksNotFoundScreen;
        }
      }

      self.setScreensData(dataToSave, function () {
        self.goToNextScreen(nextScreen);
      });
    });
  }
  setScreensData = (data, callback = false) => {
    var self = this;
    self.setState(
      {
        screensData: {
          ...self.state.screensData,
          ...data,
        },
      },
      () => {
        console.log('#### screensData ####', this.state.screensData);
        callback ? callback() : '';
      }
    );
  };
  displayAdditionalScreenContent() {
    var self = this;
    if (self.state.currentFlow == '3PLProcessingFlow') {
      return (
        <div className="">
          {this.state.currentScreen !== SCREENS.parcel_pallet_scanning_screen.key &&
            this.state.screensData.PalletType &&
            _.get(this.state.screensData, 'TrackingNumber', '') !== '' && (
              <div className="font-size-20">
                <div className="purple">{this.state.screensData.PalletType + ' Scanned '}</div>
                <div className="pink">{this.state.screensData.TrackingNumber}</div>
              </div>
            )}
        </div>
      );
    } else if (self.state.currentFlow == 'PostingFlow') {
      return (
        <div style={{ height: 30 }}>
          {this.state.currentScreen !== SCREENS.barcode_scanning_screen.key && this.state.screensData.BarcodeNumber && (
            <div className="font-size-20">
              <div className="purple">{this.state.screensData.BarcodeNumber + ' Scanned '}</div>
            </div>
          )}
        </div>
      );
    }
  }

  goToPrelistingFlow(params) {
    var self = this;
    console.log('goToPrelistingFlow params', params);
    const { foundSellerAndPickup } = params;
    if (_.isUndefined(params.doNotCheckTimeTrackingActivity)) {
      if (params.type == 'new_prelisting') {
        console.log('params.type', params.type);
        var activityType = 'PostingWarehouse';
        if (_.get(this.props.User, 'contractor._id')) {
          if (config.getEnvironmentName() !== 'local') {
            this.setState({
              activitiesListModalVisible: false,
              activityExpectedTimeModalVisible: true,
              timeTrackingActivityStartedCallback: () => {
                self.goToPrelistingFlow(_.extend(params, { doNotCheckTimeTrackingActivity: true }));
              },
              activityType: activityType,
            });
            return;
          }
        }
      }
    }

    const ProductNumber = params.match[3] == 'generate_next_number' ? params.match[3] : parseInt(params.match[3]);
    var PrelistingData = {
      reset: true,
      ScanAction: '',
      currentAction: '',
      images: _.get(params, 'images', []),
      productAction: 'AddPrelisting',
      SKU: parseInt(params.match[1]) + '.' + parseInt(params.match[2]) + '.' + parseInt(params.match[3]),
      SellerID: _.get(foundSellerAndPickup, 'SellerID._id', 'seller_not_found'),
      PickupID: _.get(foundSellerAndPickup, '_id'),
      ProductNumber: ProductNumber,
      ProductID: uuidv4(),
      CurrentProductData: {
        SellerID: {
          SellerNumber: parseInt(params.match[1]),
          InventoryOwnership: _.get(foundSellerAndPickup, 'SellerID.InventoryOwnership', ''),
          PartnerData: _.get(foundSellerAndPickup, 'SellerID.PartnerData', {}),
        },
        PickupID: { SellerPickupNumber: parseInt(params.match[2]) },
        ProductNumber: ProductNumber,
      },
      currentServiceRecord: foundSellerAndPickup,
    };
    if (params.additionalData) {
      _.extend(PrelistingData.CurrentProductData, params.additionalData);
    }
    self.setScreensData(PrelistingData, function () {
      if (_.get(params.additionalData, 'ConfirmPalletProductQuantity')) {
        self.setScreensData({ modalTitle: 'High Quantity Item', modalType: 'HighQuantityPalletItem' });
        self.setState({ pending: false, showCustomContentModal: true });
        return;
      }
      self.goToNextScreen(SCREENS.gbg_product_selection_screen.key, {
        nextScreenCallback: () => {
          if (self.state.currentFlow == 'PostingFlow') {
            self.searchByProductNameInput && ReactDOM.findDOMNode(self.searchByProductNameInput).focus();
          } else if (self.state.currentFlow == '3PLProcessingFlow') {
            self.searchUPCInput && ReactDOM.findDOMNode(self.searchUPCInput).focus();
          }
        },
      });
    });
  }
  generateNewSKU() {
    var self = this,
      functionsToCall = {};
    console.log('generateNewSKU', this.state.pending);
    if (this.state.pending) {
      return;
    }
    this.setState({ pending: true });
    this.calculateRecommendedPriceData = false;
    var dataToSave = {
      useSearchAPI: '',
      selectedSearchAPIProduct: {},
      images: [],
      similarProducts: [],
      allSimilarProducts: [],
      ProductID: uuidv4(),
      productAction: 'AddPrelisting',
      ProductCategories: prepareProductCategories.call(this, {
        selectedGBGProduct: _.get(self.state.screensData, 'selectedGBGProduct', {}),

        AllCategories: self.state.AllCategories,
      }),
      CurrentPartnerProductData: {},
    };

    if (self.FeatureFlags.DeterministicCondition) {
      delete dataToSave.images; /* keep images linked to this GBG Product */
    }
    self.doNotLookUpForAmazonProducts = false;
    if (
      _.get(dataToSave, 'selectedGBGProduct.Brand', '').toLowerCase() == 'bundle' ||
      _.find(_.get(this.state.screensData, ['ProductCategories'], []), (item) => {
        return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
      })
    ) {
      self.doNotLookUpForAmazonProducts = true;
    }
    console.log('ASIN', _.get(self.state.screensData, ['selectedGBGProduct', 'OriginalProductData', 'ASIN'], false));
    console.log(' this.doNotLookUpForAmazonProducts', self.doNotLookUpForAmazonProducts);
    functionsToCall.nextProductNumber = function (done) {
      self
        .getNextSKU()
        .then((nextProductNumber) => {
          done(null, nextProductNumber);
        })
        .catch((err) => {
          done(err);
        });
    };

    functionsToCall.getSimilarProductsData = function (done) {
      getSimilarProducts
        .call(self, { selectedGBGProduct: _.get(self.state.screensData, ['selectedGBGProduct'], {}) })
        .then((getSimilarProductsResponse) => {
          done(null, getSimilarProductsResponse);
        })
        .catch((err) => {
          console.log('err', err);
          done(err);
        });
    };
    async.parallel(functionsToCall, function (err, responses) {
      console.log('responses', responses);
      console.log('dataToSave', dataToSave);
      if (err) {
        return self.setState({ pending: false });
      }

      dataToSave.nextProductNumber = responses.nextProductNumber;

      dataToSave.ProductAgeRange = prepareProductAgeRange.call(self, {
        selectedGBGProduct: _.get(self.state.screensData, ['selectedGBGProduct'], {}),
        selectedCategories: _.get(self.state.screensData['selectedCategories'], []),
        AllCategories: self.state.AllCategories,
      });
      console.log('dataToSave 2', dataToSave);

      dataToSave.allSimilarProducts = responses.getSimilarProductsData.allSimilarProducts;
      dataToSave.similarProducts = processSimilarProducts.call(self, {
        Condition: self.state.screensData.Condition,
        allSimilarProducts: dataToSave.allSimilarProducts,
      });

      console.log('after get amazon data', dataToSave);

      var nextScreen = SCREENS.gbg_product_details_screen.key;

      if (self.state.currentFlow == '3PLProcessingFlow' && self.FeatureFlags.DeterministicCondition) {
        nextScreen = SCREENS.fees_screen.key;
      }

      if (!_.get(self.state.screensData, 'selectedGBGProduct._id')) {
        nextScreen = SCREENS.categories_screen.key;
      }

      if (
        self.state.currentFlow == '3PLProcessingFlow' &&
        _.find(_.get(self.state.screensData, ['ProductCategories'], []), (item) => {
          return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
        })
      ) {
        dataToSave.FeesToAdd = [
          {
            amount: _.get(self.state.screensData, 'currentServiceRecord.SellerID.PartnerData.DisposeCost', 0),
            Description: 'Disposal Fee',
            CustomData: { TransactionNotes: 'Donation' },
          },
        ];
      }

      self.setScreensData(dataToSave, () => {
        self.goToNextScreen(nextScreen);
      });
    });
  }

  /**
   * It seems that here is to create post-listing
   * It seems that all data that you want to send to the server you need to add to dataToSave
   * Another good point here is that everything related to screen data it will be avaliable here in this.state.screensData.
   * So if we want to some data to get here before the save we need to add them in the this.state.screensData.
   * @param {*} params
   * @returns
   */
  createListing(params = {}) {
    return new Promise(async (resolve, reject) => {
      var self = this;
      console.log('createListing', params);
      self.setState({
        pending: true,
      });
      const { SerialNumber = null } = this.state.screensData;
      let {
        AdditionalTitleDetails = '',
        DonationInventoryMetadata = null,
        selectedModelVariations = [],
      } = this.state.screensData;
      AdditionalTitleDetails = _.trim(AdditionalTitleDetails.replace(/,/g, ''));
      params.fieldsToInclude = [
        'Comments',
        'ItemsIncluded',
        'upcCodeToSave',
        'Details',
        'FeesToAdd',
        'selectedModelVariations',
      ];
      var dataToSave = await prepareAndValidateProductData.call(self, params);

      //Adding old data to be saved, this data is made here PostingSharedMethods
      if (DonationInventoryMetadata) {
        let reasons = [];
        for (let i = 0; i < selectedModelVariations.length; i++) {
          let reason = selectedModelVariations[i];
          reasons.push(reason.value);
        }
        DonationInventoryMetadata.UnableToSellReason = reasons;
        dataToSave.DonationInventoryMetadata = DonationInventoryMetadata;
      }

      console.log('Data to save ======================>', dataToSave);
      dataToSave.SerialNumber = SerialNumber;
      if (AdditionalTitleDetails) {
        var additionalTitleDetails = {
          label: 'AdditionalTitleDetails',
          AddTag: false,
          UseInTitle: true,
          value: AdditionalTitleDetails,
        };
        dataToSave.selectedModelVariations = _.concat(_.get(dataToSave, 'selectedModelVariations', []), [
          additionalTitleDetails,
        ]);
      }
      if (_.get(this.state.screensData, ['productAction'], '') == 'PostPrelisting') {
        _.extend(
          dataToSave,
          _.pick(_.get(this.state.screensDataa, ['CurrentProductData'], []), ['ProductNumber', 'Categories'])
        );
        dataToSave.PickupID = _.get(this.state.screensData, ['CurrentProductData', 'PickupID', '_id']);

        dataToSave.newGBGProductData = _.get(this.state.screensData, ['newGBGProductData'], {});
        dataToSave.selectedModelVariations = _.concat(
          _.get(dataToSave, 'selectedModelVariations', []),
          _.filter(_.get(this.state.screensData, ['CurrentProductData', 'ProductVariations'], []), (item) => {
            return item.label == 'QualityCheckInstructions' && item.value !== '[TROUBLESHOOTING ROOM]';
          })
        );
        console.log('  dataToSave.selectedModelVariations', dataToSave.selectedModelVariations);
        dataToSave.PrelistingID = this.this.state.screensData.CurrentProductData._id;
        dataToSave['_id'] = this.this.state.screensData.CurrentProductData.ProductListingID;
        dataToSave['SellerID'] = _.get(this.state.screensData, ['CurrentProductData', 'SellerID', '_id']);
      }

      console.log('name', _.get(self.state.screensData, ['selectedSearchAPIProduct', 'name'], false));
      if (_.get(self.state.screensData, ['selectedSearchAPIProduct', 'name'], false)) {
        /*   user selected Amazon product  or it is found by ASIN */

        if (
          _.get(self.state.screensData, ['selectedSearchAPIProduct', 'AmazonProduct'], false) ||
          _.get(self.state.screensData, ['selectedSearchAPIProduct', 'AmazonProductFoundByASIN'], false)
        ) {
          var AmazonProductData = prepareAmazonProductData.call(self, dataToSave);
          let fieldsToOmit = [];
          if (!_.isUndefined(dataToSave.Weight)) {
            fieldsToOmit.push('Weight'); /* use Weight from a selected GBG Product */
          }
          _.extend(dataToSave, _.omit(AmazonProductData, fieldsToOmit));
          if (!fieldsToOmit.includes('Weight') && dataToSave.Weight) {
            prepareDataForWeight.call(this, dataToSave);
          }

          var externalImageIndex = _.findIndex(self.state.screensData.images, function (image) {
            return _.get(image, ['type'], '') == 'External';
          });
          if (externalImageIndex !== -1) {
            dataToSave['ExternalImageIncluded'] = true;
          }
        }
      }

      if (
        _.includes(['PostPrelisting', 'AddPrelisting'], _.get(this.state.screensData, ['productAction'], '')) &&
        this.state.screensData.Shippable
      ) {
        if (_.isUndefined(dataToSave['Weight'])) {
          /* if user selected GBG Product  for which found Amazon product does not have weight or selected None of this or Amazon product is not found */
          if (
            _.get(this.state.screensData, 'Weight', '') == '' ||
            isNaN(parseFloat(this.state.screensData.Weight)) ||
            parseFloat(this.state.screensData.Weight) == 0
          ) {
            this.setScreensData({
              modalTitle: 'Please enter approximate weight in lbs for this item',
              modalType: 'SelectWeightModal',
            });
            this.setState({ showCustomContentModal: true, pending: false });

            return;
          } else {
            dataToSave['Weight'] = this.state.screensData.Weight;
            prepareDataForWeight.call(this, dataToSave);
          }
        }
      }
      if (!this.prepareDataForListing(dataToSave)) {
        return this.setState({
          pending: false,
        });
      }
      console.log('dataToSave', dataToSave);
      if (
        _.includes(['PostPrelisting', 'AddPrelisting'], _.get(this.state.screensData, ['productAction'], '')) &&
        _.size(_.get(dataToSave, ['ProductAgeRange'], [])) == 0
      ) {
        this.setScreensData({ modalTitle: 'Please select at least one age group', modalType: 'SelectAgeGroups' });
        return this.setState({ showCustomContentModal: true, pending: false });
      }

      dataToSave.productFlowName = 'PostingListing';
      dataToSave.processingTime = this.timerRef.getCurrentTime();

      console.log('dataToSave create listing', dataToSave);

      this.props
        .makeRequest(dataToSave, {
          endpoint: '/products',
          type: 'post',
          not_display_success_message: true,
          timeout: 25037,
        })
        .then(function (response) {
          self.timerRef.stop();
          resolve(response.data);
          self.props.displayMessage({
            messageCode: 'Listing created',
          });
        })
        .catch(function (err) {
          console.log('in error post screen', err);
          reject(err);
        });
    });
  }
  prepareDataForListing(dataToSave) {
    console.log('prepareDataForListing', dataToSave);
    var self = this;

    var dimensionNotDefined = _.find(['Width', 'Height', 'Length'], (key) => {
      return _.isUndefined(_.get(this.state.screensData, ['OriginalProductDimensions', key]));
    });
    console.log('dimensionNotDefined', dimensionNotDefined);
    console.log('OriginalProductDimensions', this.state.screensData.OriginalProductDimensions);
    if (!dimensionNotDefined) {
      dataToSave.OriginalProductDimensions = this.state.screensData.OriginalProductDimensions;
    }
    if (_.size(_.get(this.state.screensData, ['GBGProductTagsToAdd'], []))) {
      dataToSave.GBGProductTagsToAdd = _.get(this.state.screensData, ['GBGProductTagsToAdd'], []);
    }

    var boxSizeTag = _.find(dataToSave.ProductTags, function (tag) {
      return _.includes(tag, 'Box_');
    });

    console.log('boxSizeTag', boxSizeTag);
    if (_.get(this.state.screensData.productDimensions, 'Length')) {
      var selectedBoxSize = _.find(config.boxSizeList, (item) => {
        return (
          item.data.Length == _.get(this.state.screensData.productDimensions, 'Length') &&
          item.data.Width == _.get(this.state.screensData.productDimensions, 'Width') &&
          item.data.Height == _.get(this.state.screensData.productDimensions, 'Height')
        );
      });
      console.log('selectedBoxSize', selectedBoxSize);
      if (_.get(selectedBoxSize, 'value') == 'Mailer') {
        /* this.state.screensData.productDimensions is assigned when  box size is selected in the popup*/
      } else {
        dataToSave.productDimensions = this.state.screensData.productDimensions;
      }
    } else {
      /* if user did not select product dimensions, check Amazon Product dimensions */

      console.log('dimensionNotDefined', dimensionNotDefined);

      if (
        !_.find(_.get(this.state.screensData, ['ProductCategories'], []), (item) => {
          return _.includes(['Donate'], item.Category) || _.includes(['Donate'], item.Subcategory);
        }) &&
        dimensionNotDefined
      ) {
        /* do not display Dimensions modal for Donations */
        /* if dimensions are not defined, show select box size popup*/
        this.setScreensData({
          confirmDimensions: 'select_box_size',
          modalTitle: 'Please select the approximate size of this item when folded or broken down',
          modalType: 'SelectBoxSizeModal',
        });
        this.setState({ pending: false, showCustomContentModal: true });
        return;
      }
      dataToSave.productDimensions = _.get(this.state.screensData, 'OriginalProductDimensions', {});
    }

    if (
      _.get(
        this.state.screensData,
        'selectedGBGProduct.Brand',
        _.get(this.state.screensData, 'NewBrand', '')
      ).toLowerCase() == 'bundle'
    ) {
      if (!(boxSizeTag && _.get(this.state.screensData, 'confirmDimensions') == 'box_size_selected')) {
        /* if user already selected box size in the popup*/
        this.setScreensData({
          confirmDimensions: 'select_box_size',
          modalTitle: 'Please select the approximate size of this item when folded or broken down',
          modalType: 'SelectBoxSizeModal',
        });
        this.setState({
          pending: false,
          showCustomContentModal: true,
        }); /* for bundles we always display select box size popup and do not save box size tag in GBG Product*/
        return;
      }
    } else if (boxSizeTag && _.get(this.state.screensData, 'confirmDimensions') == 'box_size_selected') {
      /* if we have Box size  after user selected it*/
      dataToSave.GBGProductTagsToAdd = _.concat(_.get(dataToSave, ['GBGProductTagsToAdd'], []), [boxSizeTag]);
    } else if (!boxSizeTag) {
      /* if there is not Box_ size tag,  check if product dimensions corresponds to Shippable status */
      var productDimensionValues = _.map(dataToSave.productDimensions, (item) => {
        return parseFloat(item);
        /* parseFloat in case it is a string */
      }).sort(function (a, b) {
        return a - b;
      });
      if (productDimensionValues.length == 3) {
        //  console.log('confirmDimensions', this.state.confirmDimensions);
        console.log('productDimensionValues', dataToSave.Shippable, productDimensionValues);
        //    if (!_.get(this.props.pricingNavState.data, ['selectedGBGProduct', 'OriginalProductData', 'OriginalProductCustomData', 'DimensionsConfirmed'], false)) {
        if (productDimensionValues[0] <= 15 && productDimensionValues[1] <= 15 && productDimensionValues[2] <= 20) {
          if (!dataToSave.Shippable) {
            console.log('not shippable ', productDimensionValues);
            this.setScreensData({
              confirmDimensions: 'select_box_size',
              modalTitle: 'Please select the approximate size of this item when folded or broken down',
              modalType: 'SelectBoxSizeModal',
            });
            this.setState({
              pending: false,
              showCustomContentModal: true,
            }); /* for bundles we always display select box size popup and do not save box size tag in GBG Product*/
            return false;
          }
        } else {
          /* product dimensions are larger than 20 * 15 * 15 */
          if (dataToSave.Shippable) {
            console.log('shippable ', productDimensionValues);
            this.setScreensData({
              confirmDimensions: 'select_box_size',
              modalTitle: 'Please select the approximate size of this item when folded or broken down',
              modalType: 'SelectBoxSizeModal',
            });
            this.setState({
              pending: false,
              showCustomContentModal: true,
            }); /* for bundles we always display select box size popup and do not save box size tag in GBG Product*/
            return false;
          }
        }
      }
      if (_.get(this.state.screensData, 'calculatedBoxSize.Length')) {
        /* if calculated box size exists, use it to assign box size tag to product and GBG Product*/
        var boxSizeTagToAdd =
          'Box_' +
          this.state.screensData.calculatedBoxSize['Length'] +
          'x' +
          this.state.screensData.calculatedBoxSize['Width'] +
          'x' +
          this.state.screensData.calculatedBoxSize['Height'];
        dataToSave.ProductTags = _.concat(_.get(dataToSave, ['ProductTags'], []), [boxSizeTagToAdd]);
        dataToSave.GBGProductTagsToAdd = _.concat(_.get(dataToSave, ['GBGProductTagsToAdd'], []), [boxSizeTagToAdd]);
      }
    }
    return true;
  }
  /**
   * Here it seems that it saves prelisting
   * @param {*} params
   * @returns
   */
  savePrelisting(params = {}) {
    return new Promise(async (resolve, reject) => {
      var self = this;
      console.log('savePrelisting', this, params);
      self.setState({
        pending: true,
      });

      params.fieldsToInclude = [
        'Comments',
        'ItemsIncluded',
        'upcCodeToSave',
        'Details',
        'FeesToAdd',
        'selectedModelVariations',
      ];

      var dataToSave = await prepareAndValidateProductData.call(self, params);

      dataToSave = _.extend(dataToSave, {
        productFlowName: 'AddPrelisting',
        ProductListingID: uuidv4(),
      });

      if (!_.get(self.state.screensData, ['selectedGBGProduct', '_id'])) {
        dataToSave.ProductName = 'Pre-listing ' + dataToSave.SKUToPrint;
      }
      if (_.size(_.get(this.state.screensData, 'QualityCheckInstructions', [])) > 0) {
        var instructionToAddInTitle = {
          label: 'QualityCheckInstructions',
          AddTag: false,
          UseInTitle: true,
          value: '[' + _.get(this.state.screensData, 'QualityCheckInstructions.0.Action', '') + ']',
        };

        dataToSave.selectedModelVariations = _.concat(_.get(dataToSave, 'selectedModelVariations', []), [
          instructionToAddInTitle,
        ]);
      }
      console.log('dataToSave pre-listing', dataToSave);
      //      return resolve()

      dataToSave.processingTime = this.timerRef.getCurrentTime();

      this.props
        .makeRequest(dataToSave, {
          endpoint: '/products',
          type: 'post',
          not_display_success_message: true,
          timeout: 25037,
        })
        .then(function (response) {
          resolve(response.data);
          self.props.displayMessage({
            messageCode: 'Pre-listing created',
          });
        })
        .catch(function (err) {
          console.log('in error post screen', err);
          reject(err);
        });
    });
  }
  add3PLItems(dataToReturn) {
    const self = this;
    dataToReturn.UpdatedProductSKUs = [];
    const { RMAProductsData = {}, selectedGBGProduct = {} } = self.state.screensData;

    let add3PLItemsParams = {
      quantityAdded: parseInt(this.state.screensData.QuantityToAdd),
      productID: self.state.screensData.CurrentPartnerProductData._id,
      locationInWarehouse: self.state.screensData.LocationInWarehouse
        ? self.state.screensData.LocationInWarehouse
        : undefined,
      QuantityChangeCustomData: {
        Notes: 'Increase quantity when scanning tracking number',
        RecordActionForUser: 'product_creation',
        QuantityAdded: parseInt(this.state.screensData.QuantityToAdd),
      },
      upcCodeToSave: self.state.screensData.upcCodeToSave,
      trackingNumberData: self.state.screensData.TrackingNumbers[0],
      serialNumber: dataToReturn.serialNumber,
    };

    if (RMAProductsData.sendRMAProductProcessedEvents) {
      Object.assign(add3PLItemsParams, {
        sendRMAProductProcessedEvents: RMAProductsData.sendRMAProductProcessedEvents,
        RMAProducts: RMAProductsData.RMAProductsToUse || [],
      });
    }

    console.log('add3PLItemsParams 2', add3PLItemsParams);

    if (self.state.screensData.GBGID) {
      add3PLItemsParams.GBGID = self.state.screensData.GBGID;

      if (self.state.screensData.ServiceItemMarket) {
        add3PLItemsParams.ServiceItemMarket = self.state.screensData.ServiceItemMarket;
      }
    }

    if (_.size(this.state.screensData.FeesToAdd || [])) {
      /*  FeesToAdd included when creating a new product and not when updating it*/
      add3PLItemsParams['FeesToAdd'] = this.state.screensData.FeesToAdd.map((fee) => {
        let feeData = { feeType: fee.feeType };
        if (!_.isUndefined(fee.amount)) {
          feeData.amount = fee.amount;
        }
        return feeData;
      });
    }
    return this.props
      .makeRequest(add3PLItemsParams, {
        endpoint: '/products/3pl',
        type: 'post',
        not_display_success_message: false,
        timeout: 25037,
      })
      .then(function (response) {
        const { newProductItems, updatedProduct } = response.data;

        dataToReturn.UpdatedProductSKUs = newProductItems.map((item) => item.ProductItemSKU);
        self.props.displayMessage({
          messageType: 'success',
          messageCode:
            "Product was added successfully. If you don't see the SKU page, please, do a last check on the product quantity!",
        });
        return Promise.resolve(updatedProduct);
      })
      .catch(function (err) {
        console.log('err', err);
        if (err.response && err.response.status == 429) {
          console.log('err.response', err.response);
          self.props.displayMessage({
            messageType: 'warning',
            messageCode: 'This request was already sent. Please, confirm that product items were correctly added ',
          });
        }

        return Promise.reject(err);
      });
  }
  updatePartnerProduct(dataToReturn) {
    var TrackingNumbersToAdd = [];
    var self = this;
    var QuantityToAdd = parseInt(this.state.screensData.QuantityToAdd);

    _.forEach(_.range(0, QuantityToAdd), (index) => {
      TrackingNumbersToAdd.push({
        ..._.get(self.state.screensData, 'TrackingNumbers.0'),
        TrackingNumberAddedAt: new Date(),
      });
    });

    var params = {
      currentVersionUpdatedAt: _.get(self.state.screensData.CurrentPartnerProductData, 'updatedAt'),
      Quantity:
        _.get(self.state.screensData, 'CurrentPartnerProductData.ProductVariants.0.Quantity', 0) + QuantityToAdd,
      QuantityChangeCustomData: {
        Notes: 'Increase quantity when scanning tracking number',
        RecordActionForUser: 'product_creation',
        QuantityAdded: QuantityToAdd,
      },
      LocationInWarehouse: _.get(self.state.screensData, 'LocationInWarehouse'),
      upcCodeToSave: self.state.screensData.upcCodeToSave,
    };

    dataToReturn.UpdatedProductSKUs = [];
    if (_.size(_.get(this.state.screensData, 'FeesToAdd', []))) {
      params['FeesToAdd'] = _.map(this.state.screensData.FeesToAdd, (fee) => {
        var feeData = { feeType: fee.feeType };
        if (!_.isUndefined(fee.amount)) {
          feeData.amount = fee.amount;
        }
        return feeData;
      });
    }

    var currentSKUmatch = _.get(self.state.screensData.CurrentPartnerProductData, 'SKU').match(
      /^(\d+\.\d+\.\d+)(-.*)?$/s
    );
    if (_.get(self.state.screensData.CurrentPartnerProductData, 'ProductItems', []).length) {
      console.log('ProductItems exists ');
      params.ProductItemsToUpdate = [..._.get(self.state.screensData.CurrentPartnerProductData, 'ProductItems', [])];

      var lastLocationNumber = _.orderBy(
        _.map(params.ProductItemsToUpdate, function (item) {
          var productItemSKUMatch = _.get(item, 'ProductItemSKU', '').match(/^\d+\.\d+\.\d+\.(\d+)(-.*)?/);
          return parseInt(_.get(productItemSKUMatch, 1, 0));
        }),
        (number) => {
          return number;
        },
        'desc'
      )[0];
      _.forEach(_.range(0, QuantityToAdd), (index) => {
        lastLocationNumber = lastLocationNumber + 1;

        var ProductItemSKUToAdd = _.get(currentSKUmatch, 1, '') + '.' + lastLocationNumber;
        TrackingNumbersToAdd[index].ProductItemID = uuidv4();
        TrackingNumbersToAdd[index].ProductItemSKU = ProductItemSKUToAdd;
        params.ProductItemsToUpdate.push({
          TrackingNumber: _.get(self.state.screensData, 'TrackingNumbers.0.TrackingNumber', ''),
          ProductItemID: TrackingNumbersToAdd[index].ProductItemID,
          ProductItemSKU: TrackingNumbersToAdd[index].ProductItemSKU,
          ProductItemLocation: _.get(self.state.screensData, 'LocationInWarehouse'),
        });
        dataToReturn.UpdatedProductSKUs.push(ProductItemSKUToAdd);
      });
    } else {
      console.log('quantity', _.get(self.state.screensData, 'CurrentPartnerProductData.ProductVariants.0.Quantity', 0));
      console.log('QuantityToAdd', QuantityToAdd);
      if (_.get(self.state.screensData, 'CurrentPartnerProductData.ProductVariants.0.Quantity', 0) == 0) {
        if (QuantityToAdd == 1) {
          TrackingNumbersToAdd[0].ProductItemID = uuidv4();
          TrackingNumbersToAdd[0].ProductItemSKU = _.get(currentSKUmatch, 1, '') + '.0';
          params.ProductItemsToUpdate = [
            {
              ProductItemID: uuidv4(),
              ProductItemStatus: 'Sold',
              ProductItemSKU: _.get(currentSKUmatch, 1, ''),
              ProductItemLocation: _.get(self.state.screensData.CurrentPartnerProductData, 'LocationInWarehouse'),
            },
            {
              TrackingNumber: _.get(self.state.screensData, 'TrackingNumbers.0.TrackingNumber', ''),
              ProductItemID: TrackingNumbersToAdd[0].ProductItemID,
              ProductItemSKU: TrackingNumbersToAdd[0].ProductItemSKU,
              ProductItemLocation: _.get(self.state.screensData, 'LocationInWarehouse'),
            },
          ];
          params.SKU = _.get(currentSKUmatch, 1, '') + '-Multiple';
          params.LocationInWarehouse = 'Multiple';
          dataToReturn.UpdatedProductSKUs.push(_.get(currentSKUmatch, 1, '') + '.0');
        } else if (QuantityToAdd > 1) {
          console.log('more than 1');
          TrackingNumbersToAdd[0].ProductItemID = uuidv4();
          TrackingNumbersToAdd[0].ProductItemSKU = _.get(currentSKUmatch, 1, '');
          params.ProductItemsToUpdate = [
            {
              TrackingNumber: _.get(self.state.screensData, 'TrackingNumbers.0.TrackingNumber', ''),
              ProductItemID: TrackingNumbersToAdd[0].ProductItemID,
              ProductItemSKU: TrackingNumbersToAdd[0].ProductItemSKU,
              ProductItemLocation: _.get(self.state.screensData, 'LocationInWarehouse'),
            },
          ];
          dataToReturn.UpdatedProductSKUs.push(_.get(currentSKUmatch, 1, ''));
          _.forEach(_.range(0, QuantityToAdd - 1), (index) => {
            TrackingNumbersToAdd[index + 1].ProductItemID = uuidv4();
            TrackingNumbersToAdd[index + 1].ProductItemSKU =
              _.get(currentSKUmatch, 1, '') + '.' + (index + 1); /* start it from 1*/
            params.ProductItemsToUpdate.push({
              TrackingNumber: _.get(self.state.screensData, 'TrackingNumbers.0.TrackingNumber', ''),
              ProductItemID: TrackingNumbersToAdd[index + 1].ProductItemID,
              ProductItemSKU: TrackingNumbersToAdd[index + 1].ProductItemSKU,
              ProductItemLocation: _.get(self.state.screensData, 'LocationInWarehouse'),
            });
            dataToReturn.UpdatedProductSKUs.push(_.get(currentSKUmatch, 1, '') + '.' + (index + 1));
          });
          params.SKU = _.get(currentSKUmatch, 1, '') + '-Multiple';
          params.LocationInWarehouse = 'Multiple';
        }
      } else {
        console.log(
          'quantity more than 0',
          _.get(self.state.screensData.CurrentPartnerProductData, 'ProductVariants.0.Quantity')
        );
        params.ProductItemsToUpdate = [
          {
            //ProductItemID:TrackingNumbersToAdd[0].ProductItemID,

            ProductItemSKU: _.get(currentSKUmatch, 1, ''),
            ProductItemLocation: _.get(self.state.screensData.CurrentPartnerProductData, 'LocationInWarehouse'),
            ProductItemQuantity:
              _.get(self.state.screensData.CurrentPartnerProductData, 'ProductVariants.0.Quantity') > 1
                ? _.get(self.state.screensData.CurrentPartnerProductData, 'ProductVariants.0.Quantity')
                : undefined,
          },
        ];

        _.forEach(_.range(0, QuantityToAdd), (index) => {
          TrackingNumbersToAdd[index].ProductItemID = uuidv4();
          TrackingNumbersToAdd[index].ProductItemSKU =
            _.get(currentSKUmatch, 1, '') + '.' + (index + 1); /* start it from 1*/
          params.ProductItemsToUpdate.push({
            TrackingNumber: _.get(self.state.screensData, 'TrackingNumbers.0.TrackingNumber', ''),
            ProductItemID: TrackingNumbersToAdd[index].ProductItemID,
            ProductItemSKU: TrackingNumbersToAdd[index].ProductItemSKU,
            ProductItemLocation: _.get(self.state.screensData, 'LocationInWarehouse'),
          });
          dataToReturn.UpdatedProductSKUs.push(_.get(currentSKUmatch, 1, '') + '.' + (index + 1));
        });
        params.SKU = _.get(currentSKUmatch, 1, '') + '-Multiple';
        params.LocationInWarehouse = 'Multiple';
      }
    }

    params.TrackingNumbersToAdd = TrackingNumbersToAdd;
    console.log('params', params);
    return this.props
      .makeRequest(params, {
        endpoint: '/products/' + encodeURIComponent(self.state.screensData.CurrentPartnerProductData._id),
        timeout: 25037,
        type: 'patch',
        not_display_success_message: true,
      })
      .then((res) => {
        console.log('TrackingNumbers', _.get(res.data, 'TrackingNumbers', []));
        var TrackingNumbersAddedFound = _.find(_.get(res.data, 'TrackingNumbers', []), (trackingNumberData) => {
          console.log('trackingNumberData', trackingNumberData);
          if (TrackingNumbersToAdd[0].TrackingNumber == trackingNumberData.TrackingNumber) {
            return true;
          }
        });
        dataToReturn.TrackingNumbersAdded = _.get(TrackingNumbersAddedFound, 'TrackingNumber', false);
        return dataToReturn;
      })
      .catch((error) => {
        console.log('error data', _.get(error, 'response.data'));
        if (
          _.get(error, 'response.data.errorCode') == 'updated_by_another_user' &&
          _.get(error, 'response.data.errorMessageData.currentProductData.updatedAt')
        ) {
          console.log('updated', _.get(error, 'response.data.errorMessageData.currentProductData.updatedAt'));
          self.setScreensData({
            CurrentPartnerProductData: {
              ...self.state.screensData.CurrentPartnerProductData,
              updatedAt: _.get(error, 'response.data.errorMessageData.currentProductData.updatedAt'),
              ProductVariants: _.get(error, 'response.data.errorMessageData.currentProductData.ProductVariants'),
              ProductItems: _.get(error, 'response.data.errorMessageData.currentProductData.ProductItems'),
            },
          });
        }

        return Promise.reject(error);
      });
  }

  processPartnerProduct(params = {}) {
    const thiz = this;
    console.log('processPartnerProduct', params);
    return new Promise((resolve, reject) => {
      var self = this;

      this.setState({ pending: true });
      var functionsToPerform = {};
      var dataToReturn = {};

      const { SerialNumber = null } = self.state.screensData;
      dataToReturn.serialNumber = SerialNumber;

      if (_.get(self.state.screensData, 'CurrentPartnerProductData._id', '')) {
        dataToReturn['ProductSKU'] = _.get(self.state.screensData, 'CurrentPartnerProductData.SKU', '');
      } else {
        dataToReturn['ProductSKU'] =
          _.get(self.state.screensData, 'currentServiceRecord.SellerID.SellerNumber', '') +
          '.' +
          _.get(self.state.screensData, 'currentServiceRecord.SellerPickupNumber', '') +
          '.' +
          _.get(self.state.screensData, 'nextProductNumber', '');
      }
      if (
        self.state.currentFlow == '3PLProcessingFlow' &&
        _.get(self.state.screensData, 'CurrentPartnerProductData._id', '')
      ) {
        /* update product in 3PLProcessing flow*/
        const add3PLItemsVersion2Enabled = this.ProductsSettingsData.add3PLItemsVersion2Enabled || false;

        if (add3PLItemsVersion2Enabled) {
          functionsToPerform.add3PLItems = function (done) {
            self
              .add3PLItems(dataToReturn)
              .then((response) => {
                done(null, true);
              })
              .catch((err) => {
                console.log('err', err);
                done(err);
              });
          };
        } else {
          functionsToPerform.updatePartnerProduct = function (done) {
            self
              .updatePartnerProduct(dataToReturn)
              .then((response) => {
                done(null, true);
              })
              .catch((err) => {
                done(err);
              });
          };
        }
      } else {
        if (_.get(self.state.screensData, ['productAction'], '') == 'EditListing') {
          //  this.updateListing()
        } else {
          functionsToPerform.createPartnerProduct = function (done) {
            var methodToCall;

            if (
              self.state.currentFlow == 'PostingFlow' &&
              _.get(self.state.screensData, ['productAction'], '') == 'PostPrelisting'
            ) {
              methodToCall = self.createListing.bind(self, {});
            } else if (
              self.state.currentFlow == 'PostingFlow' &&
              _.get(self.state.screensData, ['productAction'], '') == 'AddPrelisting'
            ) {
              if (
                _.includes(
                  ['checkIntoTroubleshootingRoom', 'priceCheckPrelisting'],
                  _.get(self.state.screensData, 'productCustomData.currentProductAction')
                )
              ) {
                methodToCall = self.savePrelisting.bind(self, {});
              } else if (_.get(self.state.screensData, ['selectedGBGProduct', '_id'])) {
                methodToCall = self.createListing.bind(self, {});
              } else {
                methodToCall = self.savePrelisting.bind(self, {});
              }
            } else if (self.state.currentFlow == '3PLProcessingFlow') {
              if (
                _.includes(
                  ['checkIntoTroubleshootingRoom', 'priceCheckPrelisting'],
                  _.get(self.state.screensData, 'productCustomData.currentProductAction')
                )
              ) {
                methodToCall = self.savePrelisting.bind(self, { addProcessingFee: true });
              } else if (_.get(self.state.screensData, ['selectedGBGProduct', '_id'])) {
                methodToCall = self.createListing.bind(self, { addProcessingFee: true });
              } else {
                methodToCall = self.savePrelisting.bind(self, { addProcessingFee: true });
              }
            }

            methodToCall(dataToReturn)
              .then((response) => {
                if (self.state.currentFlow == '3PLProcessingFlow' && response.ShopifyProductHandle) {
                  dataToReturn.UpdatedProductSKUs = [dataToReturn.ProductSKU];
                } else if (self.state.currentFlow == 'PostingFlow' && response.SKU) {
                  const match = matchSKU(response.SKU, { maxDigitsNumber: 3 });

                  if (match) {
                    dataToReturn.UpdatedProductSKUs = [match[1]];
                  }
                }

                if (thiz.props.appData.FeatureFlags.EnableGenerateAllSKUs) {
                  dataToReturn.UpdatedProductSKUs = [response.SKU];
                }

                done(null, true);
              })
              .catch((err) => {
                done(err);
              });
          };
        }
      }

      if (
        this.state.currentFlow == '3PLProcessingFlow' &&
        (config.getEnvironmentName() == 'development' || config.getEnvironmentName() == 'production')
      ) {
        functionsToPerform.sendPartnerProductWebhooks = function (done) {
          self
            .sendPartnerProductWebhooks(dataToReturn)
            .then((response) => {
              done(null, true);
            })
            .catch((err) => {
              done(err);
            });
        };
        functionsToPerform.postSlackMessage = function (done) {
          self
            .postSlackMessage(dataToReturn)
            .then((response) => {
              done(null, true);
            })
            .catch((err) => {
              done(err);
            });
        };
      }

      console.log('functionsToPerform', functionsToPerform);
      async.series(functionsToPerform, function (err, responses) {
        self.setState({ pending: false });
        if (err) {
          console.log('err 1', err);
          return reject(err);
        }
        self.setScreensData(
          {
            currentServiceRecord: _.extend(
              {
                ..._.get(self.state.screensData, 'currentServiceRecord'),
                DisplayUserMessages: {
                  SentToSlackPrintingChannel: _.get(dataToReturn, 'SentToSlackPrintingChannel', false),
                  QuantityUpdated: true,
                },
              },
              dataToReturn
            ),
          },
          () => {
            resolve();
          }
        );
      });
    });
  }
  sendPartnerProductWebhook(data) {
    console.log('sendPartnerProductWebhook', data);
    data.action = 'SendPartnerProductWebhook';
    return this.props
      .makeRequest(data, {
        type: 'post',
        endpoint: '/process-action',
        not_display_success_message: true,
      })
      .then((res) => {
        return true;
      })
      .catch(function (error) {
        return Promise.reject(error);
      });
  }
  sendPartnerProductWebhooks(params) {
    return new Promise((innerResolve, innerReject) => {
      var functionsToCall = [],
        self = this;
      _.forEach(params.UpdatedProductSKUs, function (productSKU, index) {
        functionsToCall.push(function (done) {
          var WebhookData = {
            'Product SKU': params['ProductSKU'],
            'Tracking Number': _.get(self.state.screensData, 'TrackingNumbers.0.TrackingNumber', ''),
            'Invoice Cost':
              _.get(self.state.screensData, 'TrackingNumbers.0.Disposition') == 'salvage'
                ? _.get(self.state.screensData, 'currentServiceRecord.SellerID.PartnerData.DisposeCost', 0)
                : _.get(self.state.screensData, 'currentServiceRecord.SellerID.PartnerData.ProcessCost', 0),
            Disposition:
              _.get(
                _.find(config.dispositionOptions, {
                  value: _.get(self.state.screensData, 'TrackingNumbers.0.Disposition'),
                }),
                'number',
                ' '
              ) +
              ' ' +
              _.get(self.state.screensData, 'TrackingNumbers.0.Disposition', ''),
            Refundable: _.get(self.state.screensData, 'TrackingNumbers.0.Disposition') == 'salvage' ? false : true,
            Notes: _.get(self.state.screensData, 'TrackingNumbers.0.UserNotes')
              ? _.get(self.state.screensData, 'TrackingNumbers.0.UserNotes')
              : undefined,
            'Image URL': _.get(self.state.screensData, 'TrackingNumbers.0.UserImageURL')
              ? _.get(self.state.screensData, 'TrackingNumbers.0.UserImageURL')
              : undefined,
          };
          if (
            _.includes(
              _.get(self.state.screensData, 'currentServiceRecord.SellerID.PartnerData.Name', '').toLowerCase(),
              'babylist'
            )
          ) {
            WebhookData.Refundable =
              _.get(self.state.screensData, 'TrackingNumbers.0.Disposition') == 'new_condition' ? true : false;
          }

          self
            .sendPartnerProductWebhook({
              Service: 'Zapier',
              WebhookData: WebhookData,
            })
            .then((res) => {
              const currentServiceRecord = self.state.screensData.currentServiceRecord || {};
              const sellerRecord = currentServiceRecord.SellerID || {};
              if (
                _.includes(
                  _.get(self.state.screensData, 'currentServiceRecord.SellerID.PartnerData.Name', '').toLowerCase(),
                  'babylist'
                )
              ) {
                var WebhookData = {
                  tracking_number: _.get(self.state.screensData, 'TrackingNumbers.0.TrackingNumber', ''),
                  refundable:
                    _.get(self.state.screensData, 'TrackingNumbers.0.Disposition') == 'new_condition' ? true : false,
                  note:
                    _.get(self.state.screensData, 'TrackingNumbers.0.Disposition', '') +
                    ', ' +
                    params['ProductSKU'] +
                    (_.get(self.state.screensData, 'TrackingNumbers.0.UserNotes')
                      ? ', ' + _.get(self.state.screensData, 'TrackingNumbers.0.UserNotes')
                      : ''),
                };
                self
                  .sendPartnerProductWebhook({
                    Service: 'Babylist',
                    WebhookData: WebhookData,
                    SellerNumber: sellerRecord.SellerNumber,
                  })
                  .then((res) => {
                    done(null);
                  })
                  .catch(function (error) {
                    return done(error);
                  });
              } else {
                done(null);
              }
            })
            .catch(function (error) {
              return done(error);
            });
        });
      });
      async.parallel(functionsToCall, function (err, results) {
        console.log('results', results);
        innerResolve();
      });
    });
  }
  postSlackMessage(dataToReturn) {
    return new Promise((innerResolve, innerReject) => {
      var self = this;
      console.log('postSlackMessage', dataToReturn);
      var SKU = dataToReturn['ProductSKU'];
      if (_.get(dataToReturn, 'UpdatedProductSKUs', []).length > 0) {
        SKU = dataToReturn.UpdatedProductSKUs[0];
        if (_.get(dataToReturn, 'UpdatedProductSKUs', []).length > 1) {
          var baseSKUMatch = SKU.match(/^\d+\.\d+\.\d+$/);
          if (baseSKUMatch) {
            SKU += ', ' + dataToReturn.UpdatedProductSKUs[1];
            if (dataToReturn.UpdatedProductSKUs.length > 2) {
              SKU += ' - ' + _.last(dataToReturn.UpdatedProductSKUs);
            }
          } else {
            SKU += ' - ' + _.last(dataToReturn.UpdatedProductSKUs);
          }
        }
      }
      console.log('SKU', SKU);
      var params = {
        type: 'TrackingNumberForProductScanned',
        messageData: {
          text:
            (config.getEnvironmentName() !== 'production' ? '[DEV] ' : '') +
            _.get(this.state.screensData, 'currentServiceRecord.MarketName', 'Market not available') +
            '  ' +
            SKU,
        },
      };
      console.log('messageData', params);
      return this.props
        .makeRequest(params, {
          type: 'post',
          endpoint: '/send-slack-message',
          not_display_success_message: true,
        })
        .then((res) => {
          innerResolve();
        })
        .catch(function (error) {
          innerReject(error);
        });
    });
  }
  showRemoveDialog(row) {
    this.setState({ removeModalVisible: true, currentRecord: row });
  }

  deleteRecord() {
    this.setState({ removeModalVisible: false });
    var methodData = {
      type: 'delete',
      endpoint: '/orders',
      messageData: { '#1#': 'Record' },
      messageCode: 'recordDeleted',
    };
    this.props
      .makeRequest({ id: this.state.currentRecord._id }, methodData)
      .then((res) => {
        this.setState({ currentRecord: {} });
        this.search();
      })
      .catch((err) => {
        this.setState({ currentRecord: {} });
        console.log('e', err);
      });
  }

  validateAndGetPickupFormData() {
    var formData = _.pick(this.state, ['PickupDate']);
    if (!this.state.TimeWindow) {
      this.setState(
        {
          errors: {
            ...this.state.errors,
            TimeWindow: true,
          },
        },
        () =>
          this.props.displayMessage({
            messageType: 'warning',
            messageCode: 'errorFieldNotSpecified',
            messageData: { '#1#': 'Pickup time' },
          })
      );
      return false;
    }

    return formData;
  }

  saveRecord() {
    var self = this;
    this.setState({ pending: true });
    var formData = this.validateAndGetPickupFormData();
    if (!formData) {
      this.setState({ pending: false });
      return false;
    }

    var methodData = {
      endpoint: '/warehouse_pickups' + '/' + encodeURIComponent(this.state.currentRecord._id),
      type: 'patch',
    };
    self.props
      .makeRequest(formData, methodData)
      .then((recordUpdateResponse) => {
        self.setState({ pending: false });

        self.search();
        self.closeModal();
      })
      .catch((err) => {
        self.setState({ pending: false });
      });
  }

  onSortChange(field, sortOrder) {
    console.log('field', field);
    this.setState({ sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1) }, function () {
      this.refs.pagination.resetPagination();
      this.search();
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  render() {
    var self = this;
    console.log('ProductProcessingPage:::?')
    return (
      <div className="processing-page" id="processing-page">
        <div style={{ width: 240, margin: '10px auto 0' }}>
          {displayTimeTrackingButtons.call(this, { activityType: 'PostingWarehouse', changeActivityAllowed: false })}
        </div>

        {_.get(this.props.userReducer, ['customUserData', 'timeTrackingStarted'], false) !== false && (
          <div className="text-center" style={{ width: 440, margin: '10px auto 10px' }}>
            <span className="text-center top8 " style={{ fontSize: 22, verticalAlign: 'middle' }}>
              <span className="right10">{this.state.currentTimeTracked}</span>
              <span className="purple">
                {_.get(
                  _.find(config.timeTrackingActivityData, {
                    name: _.get(this.props.userReducer.customUserData, 'activityType'),
                  }),
                  'comment',
                  'activity n/a'
                )}
              </span>
            </span>
          </div>
        )}
        <div>
          {config.getEnvironmentName() !== 'production' &&
            this.state.currentScreen == SCREENS.confirmation_screen.key && (
              <Row className="left0 right0">
                <Col className="   bot30" xs={12}>
                  {this.calculateRecommendedPriceData && JSON.stringify(this.calculateRecommendedPriceData)}
                </Col>
              </Row>
            )}

          <Row>
            <Col md={9} sm={9} xs={12} className="top10">
              {displayNavigation.call(this)}
              {config.getEnvironmentName() !== 'production' &&
                this.state.currentScreen == SCREENS.quality_checks_screen.key && (
                  <div>{JSON.stringify(this.state.screensData.qualityCheckQueryParams)}</div>
                )}
            </Col>
            <Col md={3} sm={3} xs={12} className="top10 text-right">
              {this.displayAdditionalScreenContent()}
            </Col>
          </Row>
          {this.props.appData.FeatureFlags.UseGBGIDIn3PL &&
            this.state.currentFlow == '3PLProcessingFlow' &&
            !this.FeatureFlags.Processing3PLByManager && (
              <Row>
                <Col xs={12} className="top10 text-center">
                  {displaySellerAndPickupData.call(self)}
                </Col>
              </Row>
            )}
          {this.props.appData.FeatureFlags.DisplayTimerOnProcessing === true && (
            <Row>
              <Col xs={12} className="top10 text-center">
                <Timer
                  ref={(timerRef) => {
                    this.timerRef = timerRef;
                  }}
                />
              </Col>
            </Row>
          )}
          {displayScreenContent.call(this)}
        </div>

        {displayCustomDialog.call(this, {
          cancelButtonTitle: 'Close',
          buttonTitle: this.state.screensData.modalType == 'HighQuantityPalletItem' ? 'Confirm' : 'doNotDisplay',
          dialogContent: () => {
            console.log('dialog content', this.state.screensData.modalType);
            switch (this.state.screensData.modalType) {
              case 'SelectBoxSizeModal':
                return (
                  <div>
                    {renderDimensionsVerticalView.call(this, [
                      [
                        {
                          imageSource: '/theme/assets/dimensions/mailer.jpeg',
                          ..._.find(config.boxSizeList, (item) => {
                            return _.includes(item.label.toLowerCase(), 'mailer');
                          }),
                        },
                        {
                          imageSource: '/theme/assets/dimensions/8-8-5.jpg',
                          ..._.find(config.boxSizeList, (item) => {
                            return item.data.Length == 8 && item.data.Width == 8 && item.data.Height == 5;
                          }),
                        },
                      ],

                      [
                        {
                          imageSource: '/theme/assets/dimensions/12-9-6.jpg',
                          ..._.find(config.boxSizeList, (item) => {
                            return item.data.Length == 12 && item.data.Width == 9 && item.data.Height == 6;
                          }),
                        },
                        {
                          imageSource: '/theme/assets/dimensions/14-10-10.png',
                          ..._.find(config.boxSizeList, (item) => {
                            return item.data.Length == 14 && item.data.Width == 10 && item.data.Height == 10;
                          }),
                        },
                      ],
                      [
                        {
                          imageSource: '/theme/assets/dimensions/20-16-6.png',
                          ..._.find(config.boxSizeList, (item) => {
                            return item.data.Length == 20 && item.data.Width == 16 && item.data.Height == 6;
                          }),
                        },
                        {
                          imageSource: '/theme/assets/dimensions/15-15-15.png',
                          ..._.find(config.boxSizeList, (item) => {
                            return item.data.Length == 15 && item.data.Width == 15 && item.data.Height == 15;
                          }),
                        },
                      ],
                      [
                        {
                          imageSource: '/theme/assets/dimensions/32-18-6.jpeg',
                          ..._.find(config.boxSizeList, (item) => {
                            return item.data.Length == 32 && item.data.Width == 18 && item.data.Height == 8;
                          }),
                        },
                        {
                          imageSource: '/theme/assets/dimensions/42-12-12.jpeg',
                          ..._.find(config.boxSizeList, (item) => {
                            return item.data.Length == 44 && item.data.Width == 12 && item.data.Height == 12;
                          }),
                        },
                      ],
                      [
                        {
                          imageSource: '/theme/assets/dimensions/30-20-20.jpeg',
                          ..._.find(config.boxSizeList, (item) => {
                            return item.data.Length == 30 && item.data.Width == 20 && item.data.Height == 20;
                          }),
                        },
                        {
                          imageSource: '/theme/assets/dimensions/or_larger.jpeg',
                          ..._.find(config.boxSizeList, (item) => {
                            return item.data.Length == 38 && item.data.Width == 28 && item.data.Height == 18;
                          }),
                        },
                      ],
                    ])}
                  </div>
                );
              case 'SelectWeightModal':
                return (
                  <div>
                    <div className="top30 set-width" style={{ margin: '0 auto' }}>
                      <FormControl
                        value={_.get(this.state.screensData, 'Weight', '')}
                        placeholder=""
                        onChange={(e) => {
                          self.setScreensData({ Weight: e.target.value });
                        }}
                        type="text"
                      />
                    </div>
                  </div>
                );
              case 'SelectGBGProductTags':
                return (
                  <div>
                    <div className="top30 set-width" style={{ margin: '0 auto' }}>
                      {_.map(this.state.screensData.allGBGProductTagsToAssign, (item, index) => {
                        return (
                          <Checkbox
                            key={index}
                            onChange={() => {
                              var tagIndex = _.findIndex(self.state.screensData.GBGProductTagsToAssign, {
                                value: item.value,
                              });
                              console.log('tagIndex', tagIndex);

                              if (tagIndex == -1) {
                                var GBGProductTagsToAssign = _.concat(
                                  [...self.state.screensData.GBGProductTagsToAssign],
                                  [{ ...item }]
                                );
                              } else {
                                var GBGProductTagsToAssign = [
                                  ...self.state.screensData.GBGProductTagsToAssign.slice(0, tagIndex),
                                  ...self.state.screensData.GBGProductTagsToAssign.slice(tagIndex + 1),
                                ];
                              }
                              console.log('GBGProductTagsToAssign', GBGProductTagsToAssign);
                              this.setScreensData({ GBGProductTagsToAssign: GBGProductTagsToAssign });
                            }}
                            checked={_.includes(
                              _.map(self.state.screensData.GBGProductTagsToAssign, 'value'),
                              item.value
                            )}
                          >
                            <span>{item.label}</span>
                          </Checkbox>
                        );
                      })}
                    </div>
                  </div>
                );
              case 'HighQuantityPalletItem':
                if (_.get(this.state.screensData.CurrentProductData, 'ProductItems', []).length > 11) {
                  var barcodesList = (
                    <div>
                      {_.get(this.state.screensData, 'CurrentProductData.ProductItems.0.ProductItemSKU', []) +
                        ' . . . ' +
                        _.get(this.state.screensData, [
                          'CurrentProductData',
                          'ProductItems',
                          _.get(this.state.screensData, 'CurrentProductData.ProductItems', []).length - 1,
                          'ProductItemSKU',
                        ])}
                    </div>
                  );
                } else {
                  var barcodesList = _.map(
                    _.get(this.state.screensData.CurrentProductData, 'ProductItems', []),
                    (producItem) => {
                      return <div>{_.get(producItem, 'ProductItemSKU', '')} </div>;
                    }
                  );
                }
                return (
                  <div>
                    <div className="  font-size-17 bot15   text-left">
                      {_.get(this.state.screensData, 'CurrentProductData.ProductItems', []).length > 0
                        ? 'Please confirm quantity and tag with the following barcodes'
                        : 'Please confirm quantity to begin.'}
                    </div>
                    <div className="  bot20">
                      <span>Quantity: </span>
                      <span className="text-bold cyen">
                        {_.get(this.state.screensData, 'CurrentProductData.ConfirmPalletProductQuantity', '')}{' '}
                      </span>
                    </div>
                    {_.get(this.state.screensData, 'CurrentProductData.ProductItems', []).length > 0 && (
                      <div className="text-bold purple font-size-17 bot5   text-left">{barcodesList}</div>
                    )}
                  </div>
                );
              case 'SelectAgeGroups':
                return (
                  <div>
                    <div className="top30 set-width" style={{ margin: '0 auto' }}>
                      {_.map(getAllowedAgeGroups(), (item, index) => {
                        return (
                          <Checkbox
                            key={index}
                            onChange={() => {
                              var itemIndex = _.findIndex(_.get(self.state.screensData, 'ProductAgeRange', []), {
                                value: item.value,
                              });
                              console.log('itemIndex', itemIndex);

                              if (itemIndex == -1) {
                                var ProductAgeRange = _.concat(
                                  [..._.get(self.state.screensData, 'ProductAgeRange', [])],
                                  [{ ...item }]
                                );
                              } else {
                                var ProductAgeRange = [
                                  ..._.get(self.state.screensData, 'ProductAgeRange', []).slice(0, itemIndex),
                                  ..._.get(self.state.screensData, 'ProductAgeRange', []).slice(itemIndex + 1),
                                ];
                              }
                              this.setScreensData({ ProductAgeRange: ProductAgeRange });
                            }}
                            checked={_.includes(
                              _.map(_.get(self.state.screensData, 'ProductAgeRange', []), 'value'),
                              item.value
                            )}
                          >
                            <span>{item.label}</span>
                          </Checkbox>
                        );
                      })}
                    </div>
                  </div>
                );
              case 'DisplayImageModal':
                return (
                  <div>
                    <div className="top30 set-width" style={{ margin: '0 auto' }}>
                      <img
                        className=" "
                        onClick={(e) => {
                          self.setState({ showCustomContentModal: false });
                          self.setScreensData({
                            modalTitle: '',
                            modalType: '',
                            imageToDisplay: '',
                          });
                        }}
                        style={{ width: '100%', height: '100%', cursor: 'pointer' }}
                        src={this.state.screensData.imageToDisplay}
                      ></img>
                    </div>
                  </div>
                );
            }
          },
          cancelActionHandler: () => {},
          confirmActionHandler: (data) => {
            if (self.state.screensData.modalType == 'HighQuantityPalletItem') {
              self.goToNextScreen(SCREENS.gbg_product_selection_screen.key, {
                nextScreenCallback: () => {
                  if (self.state.currentFlow == 'PostingFlow') {
                    self.searchByProductNameInput && ReactDOM.findDOMNode(self.searchByProductNameInput).focus();
                  } else if (self.state.currentFlow == '3PLProcessingFlow') {
                    self.searchUPCInput && ReactDOM.findDOMNode(self.searchUPCInput).focus();
                  }
                },
              });
            }
          },
          modalTitle: this.state.screensData.modalTitle,
          dialogID: 'CustomContentModal',
        })}

        {displayCustomDialog.call(this, {
          cancelButtonTitle: 'Cancel',
          buttonTitle: 'Yes',
          cancelActionHandler: () => {
            this.setState({ showCustomDialogID: false });
          },

          confirmActionHandler: (data) => {
            var self = this;
            self.setState({ showCustomDialogID: false });
            var dataToUpdate = {},
              nextScreen = SCREENS.gbg_product_details_screen.key;
            if (this.state.screensData.selectedAction == 'Donation') {
              self.setState({ pending: true });
              prepareDataForDonation
                .call(self)
                .then((dataToUpdate) => {
                  self.setScreensData(dataToUpdate, () => {
                    // if (this.state.currentFlow == '3PLProcessingFlow'){
                    //     nextScreen =SCREENS.location_scanning_screen.key
                    //  }
                    self.goToNextScreen(nextScreen);
                  });
                })
                .catch((err) => {
                  self.setState({ pending: false });
                  console.log('err', err);
                });
            } else if (this.state.screensData.selectedAction == 'TroubleshootingRoom') {
              dataToUpdate.QualityCheckInstructions = [{ Action: 'TROUBLESHOOTING ROOM' }];
              dataToUpdate.productCustomData = _.extend({}, _.get(this.state.screensData, 'productCustomData', {}), {
                currentProductAction: 'checkIntoTroubleshootingRoom',
              });

              self.setScreensData(dataToUpdate, () => {
                self.goToNextScreen(SCREENS.instructions_details_screen.key);
              });
            }
          },
          modalTitle: this.state.screensData.modalTitle,
          dialogID: 'CustomDialogID',
        })}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    userReducer: state.userReducer,
    allSellersList: state.allSellersList,
    appData: state.appData,
    allSellerPickupsListReducer: state.allSellerPickupsListReducer,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ makeRequest, getCurrentStoreState, dispatchAction, displayMessage }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(hot(ProductProcessingPage));
